<!--
 * @Descripttion: 20230915 更换手动控制前
 * @version: 
 * @Author: szj
 * @Date: 2023-03-06 09:05:38
 * @LastEditors: szj
 * @LastEditTime: 2025-04-11 11:34:58
-->
<template>
  <div class="map-box">
    <div
      class="g-map-wrapper"
      :class="switchVedio ? 'map-wrapper-active' : 'vedio-box-active'"
      :style="{ bottom: switchVedio ? `${290 * mapNum + 10}px` : '' }"
      v-show="shrinkMap"
    >
      <div id="g-container" :style="{ width: '100%', height: '100%' }" />
      <div id="frustummap"></div>
      <div class="bottom-tool">
        <div><span></span>{{ lonLatAlt[0] || 0 }}° E</div>
        <div class="ml2"><span></span>{{ lonLatAlt[1] || 0 }}° N</div>
        <div class="ml2"><span></span>{{ altHeight || 0 }}m</div>
      </div>
      <!-- 指南针 -->
      <div class="gmap-heading-box">
        <MapHead
          :mapcompassInfo="mapcompassInfo"
          @resetHeading="resetHeading"
        />
      </div>
      <!-- 手控状态 -->
      <div class="control-status-box">
        <div class="flex-center">
          <div>
            <a-tooltip title="姿态">
              <img :src="zitai" alt="" style="width: 16px" />
              <span>
                <span v-if="controlStatusMessage?.movement == '左旋转'"
                  ><UndoOutlined
                /></span>
                <span v-if="controlStatusMessage?.movement == '右旋转'"
                  ><RedoOutlined
                /></span>
                <span v-if="controlStatusMessage?.movement == '前进'"
                  ><UpOutlined
                /></span>
                <span v-if="controlStatusMessage?.movement == '后退'"
                  ><DownOutlined
                /></span>
                <span v-if="controlStatusMessage?.movement == '右移'"
                  ><RightOutlined
                /></span>
                <span v-if="controlStatusMessage?.movement == '左移'"
                  ><LeftOutlined
                /></span>
                <span v-if="controlStatusMessage?.movement == '上升'"
                  ><ArrowUpOutlined
                /></span>
                <span v-if="controlStatusMessage?.movement == '下降'"
                  ><ArrowDownOutlined
                /></span>
                <span>
                  {{ controlStatusMessage?.movement }}
                </span>
              </span>
            </a-tooltip>
          </div>
          <div>
            <a-tooltip title="">
              <div style="display: flex; align-items: center">
                <div class="circles">S.T</div>
                <div
                  class="blocks"
                  :style="{ background: bolmqttFlags ? 'green' : 'red' }"
                ></div>
              </div>
            </a-tooltip>
          </div>
        </div>
        <div class="flex-center">
          <div>
            <a-tooltip title="垂直速度">
              <div style="display: flex">
                <div class="circles">V.S</div>
                <span
                  class="txt12"
                  v-if="
                    controlStatusMessage?.horizontalSpeed ||
                    controlStatusMessage?.horizontalSpeed == 0
                  "
                  >{{
                    controlStatusMessage?.horizontalSpeed
                      ? controlStatusMessage?.horizontalSpeed?.toFixed(2) +
                        "m/s"
                      : "0m/s"
                  }}</span
                >
              </div>
            </a-tooltip>
          </div>
          <div>
            <a-tooltip title="水平速度">
              <div style="display: flex">
                <div class="circles">H.S</div>
                <span
                  class="txt12"
                  v-if="
                    controlStatusMessage?.verticalSpeed ||
                    controlStatusMessage?.verticalSpeed == 0
                  "
                  >{{
                    controlStatusMessage?.verticalSpeed
                      ? controlStatusMessage?.verticalSpeed?.toFixed(2) + "m/s"
                      : "0m/s"
                  }}</span
                >
              </div>
            </a-tooltip>
          </div>
        </div>
        <div class="flex-center">
          <div>
            <a-tooltip title="海拔">
              <div style="display: flex">
                <div class="circles">AGL</div>
                <span class="txt12" v-if="controlStatusMessage?.height">{{
                  controlStatusMessage?.height?.toFixed(1) + "m"
                }}</span>
              </div>
            </a-tooltip>
          </div>
          <div>
            <a-tooltip title="风速">
              <div style="display: flex">
                <img
                  :src="fensu"
                  alt=""
                  style="width: 16px; margin-right: 5px; margin-top: 5px"
                />
                <span
                  class="txt12"
                  v-if="
                    controlStatusMessage?.windSpeed ||
                    controlStatusMessage?.windSpeed == 0
                  "
                  >{{
                    controlStatusMessage?.windSpeed
                      ? (controlStatusMessage?.windSpeed / 10)?.toFixed(2) +
                        "m/s"
                      : "0m/s"
                  }}</span
                >
              </div>
            </a-tooltip>
          </div>
        </div>
      </div>
      <!-- 地图右上画线 -->
      <div class="g-action-panle">
        <!-- :style="{ right: drawVisible ? '316px' : '16px' }" -->
        <div
          :class="
            state.currentType === 'pin'
              ? 'g-action-item selection'
              : 'g-action-item'
          "
          @click="draw('pin', true)"
        >
          <a><a-image :src="pin" :preview="false" /></a>
        </div>
        <div
          :class="
            state.currentType === 'polyline'
              ? 'g-action-item selection'
              : 'g-action-item'
          "
          @click="draw('polyline', true)"
        >
          <a><LineOutlined :rotate="135" class="fz20" /></a>
        </div>
        <div
          :class="
            state.currentType === 'polygon'
              ? 'g-action-item selection'
              : 'g-action-item'
          "
          @click="draw('polygon', true)"
        >
          <a><BorderOutlined class="fz18" /></a>
        </div>
        <div v-if="mouseMode" class="g-action-item" @click="draw('off', false)">
          <a style="color: red"><CloseOutlined /></a>
        </div>
      </div>
      <!-- 地图标记图层 -->
      <div @mouseover="showLayer" @mouseleave="hideLayer">
        <div class="layers-box1">
          <div class="layers">
            <!-- 星图 -->
            <div class="layer-overhide" v-if="layerVisible == 2">星图</div>
            <!-- 自有 -->
            <div class="layer-overhide" v-if="layerVisible == 3">自有</div>
            <div class="layer-overhide" v-if="layerVisible == 1">cesium</div>
            <div class="layer-overhide" v-if="layerVisible == 4">mapbox</div>
          </div>
        </div>
        <!--  -->
        <div class="layers-type" v-show="isShowLayer">
          <div class="mb15 flex-display">
            <div>地图图层</div>
            <div style="margin-left: 10px">
              <a-switch v-model:checked="buildSwitch" @change="buildChange" />
              <span>工地</span>
            </div>
          </div>
          <div class="flex-display flex-justify-between">
            <div
              class="layers-starand layers-bg"
              @click="starandLayerXin"
              :class="layerVisible == 2 ? 'layer-border' : ''"
            >
              <div
                class="layer-text"
                :class="layerVisible == 2 ? 'layer-bg' : ''"
              >
                星图地图
              </div>
            </div>
            <div
              class="layers-ziyou layers-bg"
              @click="starandLayer"
              :class="layerVisible == 3 ? 'layer-border' : ''"
            >
              <div
                class="layer-text"
                :class="layerVisible == 3 ? 'layer-bg' : ''"
              >
                自有地图
              </div>
            </div>
            <div
              class="layers-star layers-bg"
              @click="starLayer"
              :class="layerVisible == 1 ? 'layer-border' : ''"
            >
              <div
                class="layer-text"
                :class="layerVisible == 1 ? 'layer-bg' : ''"
              >
                cesium地图
              </div>
            </div>
            <div
              class="layers-star layers-bg"
              @click="starLayerMapbox"
              :class="layerVisible == 4 ? 'layer-border' : ''"
            >
              <div
                class="layer-text"
                :class="layerVisible == 4 ? 'layer-bg' : ''"
              >
                mapbox地图
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- osdVisible.visible && !osdVisible.is_dock -->
      <div v-if="false" class="osd-panel fz12">
        <div
          class="pl5 pr5 flex-align-center flex-row flex-justify-between"
          style="border-bottom: 1px solid #515151; height: 18%"
        >
          <span>{{ osdVisible.callsign }}</span>
          <span
            ><a
              class="fz16"
              style="color: white"
              @click="() => (osdVisible.visible = false)"
              ><CloseOutlined /></a
          ></span>
        </div>
        <div style="height: 82%">
          <div
            class="flex-column flex-align-center flex-justify-center"
            style="
              margin-top: -5px;
              padding-top: 25px;
              float: left;
              width: 60px;
              background: #2d2d2d;
            "
          >
            <a-tooltip :title="osdVisible.model">
              <div
                style="width: 90%"
                class="flex-column flex-align-center flex-justify-center"
              >
                <span><a-image :src="M30" :preview="false" /></span>
                <span>{{ osdVisible.model }}</span>
              </div>
            </a-tooltip>
          </div>
        </div>
        <div
          class="battery-slide"
          v-if="deviceInfo.device.battery.remain_flight_time !== 0"
        >
          <div style="background: #535759" class="width-100"></div>
          <div
            class="capacity-percent"
            :style="{ width: deviceInfo.device.battery.capacity_percent + '%' }"
          ></div>
          <div
            class="return-home"
            :style="{
              width: deviceInfo.device.battery.return_home_power + '%',
            }"
          ></div>
          <div
            class="landing"
            :style="{ width: deviceInfo.device.battery.landing_power + '%' }"
          ></div>
          <div
            class="white-point"
            :style="{ left: deviceInfo.device.battery.landing_power + '%' }"
          ></div>
          <div
            class="battery"
            :style="{ left: deviceInfo.device.battery.capacity_percent + '%' }"
          >
            {{ Math.floor(deviceInfo.device.battery.remain_flight_time / 60) }}:
            {{
              10 > deviceInfo.device.battery.remain_flight_time % 60 ? "0" : ""
            }}{{ deviceInfo.device.battery.remain_flight_time % 60 }}
          </div>
        </div>
      </div>
      <!-- 地图错误弹框 -->
      <div v-if="maperrorFlag">
        <MapError />
      </div>
    </div>
    <div
      v-for="(item, index) in onlineVedioData"
      :key="index"
      class="vedio-box"
      :style="{ bottom: `${330 * item.bottomNum + 10}px` }"
      v-show="item.dockStatus && item.isShow"
      :class="
        !switchVedio
          ? 'map-wrapper-active'
          : index == mapNum
          ? 'vedio-box-active'
          : 'zindex10'
      "
    >
      <div style="height: 100%">
        <div
          class="switch-btn"
          @click="switchDiv(index)"
          v-show="isSwichShrink(index)"
          :style="{ bottom: `${330 * item.bottomNum + 305}px` }"
        >
          <a-tooltip placement="top">
            <template #title>
              <span>切换</span>
            </template>
            <SwapOutlined />
          </a-tooltip>
        </div>
        <div
          class="shrink-box"
          @click="shrinkBox(index)"
          :style="{ bottom: `${330 * item.bottomNum + 305}px` }"
          v-show="isSwichShrink(index)"
        >
          <a-tooltip placement="top">
            <template #title>
              <span>隐藏</span>
            </template>
            <FullscreenExitOutlined />
          </a-tooltip>
        </div>
        <div style="width: 100%; height: 100%">
          <GMapVedio
            :checkPlaneSn="item.planSn"
            :checkDockSn="item.dockSn"
            :checkPlaneMode="item.planStatus"
            :payloads="item.payloads"
            :toVedioDatas="toVedioDatas"
            :deviceInfo="deviceinfoObj"
          />
        </div>
      </div>
    </div>
    <!-- 视频小盒子收缩后的图标  -->
    <div
      class="boost-box"
      @click="boostBox(index)"
      v-for="(item, index) in onlineVedioData"
      :key="index"
      v-show="item.dockStatus && !item.isShow"
      :style="{ bottom: `${45 * index + 65}px` }"
    >
      <div>
        <a-tooltip placement="left">
          <template #title>
            <span>{{ item.title }}</span>
          </template>
          <div style="font-size: 16px">
            {{ index + 1 }}
          </div>
        </a-tooltip>
      </div>
    </div>
    <div
      class="boost-box"
      @click="boostBox(-1)"
      v-show="!shrinkMap"
      :style="{ bottom: `${45 * mapNum + 65}px` }"
    >
      <a-tooltip placement="top">
        <template #title>
          <span>显示</span>
        </template>
        <FullscreenOutlined />
      </a-tooltip>
    </div>
    <!-- 手动控制  -->
    <div v-show="authIds?.includes('11')">
      <div v-show="panelControlFlag">
        <div class="control-box" v-show="shrinkControl">
          <div class="control-shrink" @click="controlShrink">
            <CaretDownOutlined />
          </div>
          <GMapControl
            :checkPlanSn="checkPlaneSn"
            @leftDoubleClick="leftDoubleClick"
            @mappitch="mappitch"
            :taskJobId="taskJobId"
            :planesn="checkPlaneSn"
            :checkDockSn="checkDockSn"
            :wayStatus="wayStatus"
            :checkDeviceInfo="deviceinfoObj"
            :panelControlFlag="panelControlFlag"
            @mapclick="mapclick"
            @aimpoints="aimpoints"
            @aircraftpositionings="aircraftpositionings"
            @cancalemapclick="cancalemapclick"
            @rightclick="rightclick"
            @cleardata="cleardata"
            @toVedio="toVedio"
          />
          <!-- <GMapControl :checkPlaneSn="checkPlaneSn" @mappitch="mappitch"   :taskJobId="taskJobId" :planesn="checkPlaneSn" :sn="checkDockSn" :wayStatus="wayStatus" :deviceInfo="deviceInfos" :panelControlFlag="panelControlFlag" @mapclick="mapclick" @aimpoints="aimpoints" @aircraftpositionings="aircraftpositionings" @cancalemapclick="cancalemapclick" @rightclick="rightclick" @cleardata="cleardata" @toVedio="toVedio" /> -->
        </div>
      </div>
      <div class="control-box-shrink" v-if="!shrinkControl">
        <div @click="controlBoost">
          <CaretUpOutlined />
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {
  computed,
  defineComponent,
  onMounted,
  onUnmounted,
  reactive,
  ref,
  onBeforeUnmount,
  watch,
  createVNode,
} from "vue";
// import {
//   generateLineContent,
//   generatePointContent,
//   generatePolyContent,
// } from "../utils/map-layer-utils";
import { postElementsReq, getElementGroupsReq } from "/@/api/layer";
import { MapDoodleType, MapElementEnum } from "/@/constants/map";
import { useGMapManage } from "/@/hooks/use-g-mapcesuim";
// import { useGMapCover } from "/@/hooks/use-g-map-cover";
// import { useMouseTool } from "/@/hooks/use-mouse-tool";
import { getApp, getRoot } from "/@/root";
import { useMyStore } from "/@/store";
import { GeojsonCoordinate } from "/@/types/map";
import { PostElementsBody } from "/@/types/mapLayer";
import { gcj02towgs84, wgs84togcj02 } from "/@/vendors/coordtransform";
import { deviceTsaUpdate } from "/@/hooks/use-g-map-tsacesuim";
import mouseTools from "/@/hooks/mouse-tool/plot/drawTool";
import pin2d8cf0 from "/@/assets/icons/pin-2d8cf0.svg";
import zitai from "/@/assets/icons/zitai.png";
import chuizhi from "/@/assets/icons/chuizhi.png";
import fensu from "/@/assets/icons/fensu.png";
import haiba from "/@/assets/icons/haiba.png";
import shuiping from "/@/assets/icons/shuiping.png";
import { message, Modal } from "ant-design-vue";
import {
  DeviceOsd,
  DeviceStatus,
  DockOsd,
  EGear,
  EModeCode,
  GatewayOsd,
  EDockModeCode,
  NetworkStateQualityEnum,
  NetworkStateTypeEnum,
  RainfallEnum,
  DroneInDockEnum,
} from "/@/types/device";
import pin from "/@/assets/icons/pin-2d8cf0.svg";
import M30 from "/@/assets/icons/m30.png";
import Arrow from "/@/assets/icons/arrow.png";
import {
  BorderOutlined,
  MinusCircleOutlined,
  LineOutlined,
  CloseOutlined,
  ControlOutlined,
  TrademarkOutlined,
  ArrowDownOutlined,
  ThunderboltOutlined,
  SignalFilled,
  GlobalOutlined,
  HistoryOutlined,
  CloudUploadOutlined,
  RocketOutlined,
  FieldTimeOutlined,
  CloudOutlined,
  CloudFilled,
  FolderOpenOutlined,
  RobotFilled,
  ArrowUpOutlined,
  CarryOutOutlined,
  SwapOutlined,
  FullscreenExitOutlined,
  FullscreenOutlined,
  CaretDownOutlined,
  CaretUpOutlined,
  UndoOutlined,
  RedoOutlined,
  RightOutlined,
  LeftOutlined,
  UpOutlined,
  ExclamationCircleOutlined,
  DownOutlined,
} from "@ant-design/icons-vue";
import DockControlPanel from "./g-map/DockControlPanel.vue";
import { getFlyNum, setBuildFlagApi, getBuildFlagApi } from "/@/api/sys/sys";
import { sysType } from "/@/types/task";
import GMapVedio from "./g-map/GMapVedio.vue";
import GMapLayer from "./g-map/GmapLayer.vue";
import GMapControl from "./g-map/GMapControl.vue";
import { useDockControl } from "./g-map/useDockControl";
import { EDeviceTypeName, ELocalStorageKey } from "/@/types";
import { getDeviceTopo, getBuildListApi } from "/@/api/manage";
import { useDroneControl } from "./g-map/use-drone-control";
import {
  getMapDataApi,
  mapUrlList,
  judgeArrNaN,
  safeParseFloat,
  isValidArray,
} from "/@/utils/common";
import JessibucaVedio from "./g-map/JessibucaVedio.vue";
import MapError from "/@/components/mapError.vue";
import { loadModel } from "/@/hooks/use-map-model";
import MapHead from "/@/components/mapHead.vue";

export default defineComponent({
  components: {
    BorderOutlined,
    MinusCircleOutlined,
    LineOutlined,
    CloseOutlined,
    ControlOutlined,
    TrademarkOutlined,
    ThunderboltOutlined,
    SignalFilled,
    GlobalOutlined,
    HistoryOutlined,
    CloudUploadOutlined,
    FieldTimeOutlined,
    CloudOutlined,
    CloudFilled,
    FolderOpenOutlined,
    RobotFilled,
    ArrowUpOutlined,
    ArrowDownOutlined,
    DockControlPanel,
    GMapVedio,
    GMapLayer,
    GMapControl,
    CarryOutOutlined,
    RocketOutlined,
    SwapOutlined,
    FullscreenExitOutlined,
    FullscreenOutlined,
    CaretDownOutlined,
    CaretUpOutlined,
    UndoOutlined,
    RedoOutlined,
    UpOutlined,
    RightOutlined,
    LeftOutlined,
    DownOutlined,
    JessibucaVedio,
    MapError,
    MapHead,
  },
  name: "GMap",
  props: {
    wayPath: {
      type: Object,
    },
    overwayPath: {
      type: Object,
    },
    deviceAll: {
      type: Object,
    },
    // 飞行控制点的信息
    aimpoint: {
      type: Object,
    },
    // 飞行控制轨迹的信息
    aimpositionings: {
      type: Object,
    },
    // 选中机场的sn
    checkDockSn: {
      type: String,
    },
    // 选中飞机的sn
    checkPlaneSn: {
      type: String,
    },
    // 选中飞机的状态
    checkPlaneMode: {
      type: Number,
    },
    // 负载控制
    payloads: {
      type: Object,
    },
    // 飞机的实时信息
    deviceInfos: {
      type: Object,
    },
    // 左边的所有机场
    onlineDocks: {
      type: Object,
    },
    // 正在执行任务的jonid，用于恢复航线
    taskJobId: {
      type: String,
    },
    wayStatus: {
      type: Boolean,
    },
    // 一键起飞成功后,绘制航线
    flysucesswayline: {
      type: Boolean,
    },
    // 飞机为手控 航线时,地图右键飞到此处,true为解开地图右键点击事件
    flysucessrightclick: {
      type: Boolean,
      default: false,
    },
    panelControlFlag: {
      type: Boolean,
    },
    // 清除地图上的目标点覆盖物,默认是true不清除,只有当飞机和机场均为空闲时清除
    clearmapaim: {
      type: Boolean,
      default: true,
    },
    // 选中的某个机场
    checkDockNum: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    // const useMouseToolHook = useMouseTool();
    const useGMapManageHook = useGMapManage();
    const deviceTsaUpdateHook = deviceTsaUpdate();
    const loadModelHook = loadModel(); // 三维模型实例化方法
    const root = getRoot();
    const mouseMode = ref(false);
    const store = useMyStore();
    const state = reactive({
      currentType: "",
      coverIndex: 0,
    });
    const str: string = "--";
    const lonLatAlt = ref<any>([]);
    const altHeight = ref<any>(0);
    const deviceInfo = reactive({
      gateway: {
        capacity_percent: str,
        transmission_signal_quality: str,
      } as GatewayOsd,
      dock: {} as DockOsd,
      device: {
        gear: -1,
        mode_code: EModeCode.Disconnected,
        height: str,
        home_distance: str,
        horizontal_speed: str,
        vertical_speed: str,
        wind_speed: str,
        wind_direction: str,
        elevation: str,
        position_state: {
          gps_number: str,
          is_fixed: 0,
          rtk_number: str,
        },
        battery: {
          capacity_percent: str,
          landing_power: str,
          remain_flight_time: 0,
          return_home_power: str,
        },
        latitude: 0,
        longitude: 0,
      } as DeviceOsd,
    });
    const mapLayers = ref(store?.state.Layers);
    const shareId = computed(() => {
      return store?.state.layerBaseInfo.share;
    });
    const authIds = ref<any>([]);
    // const defaultId = computed(() => {
    //   return store.state.layerBaseInfo.default;
    // });
    // 工地开关 true为打开工地标记 false为关闭
    const buildSwitch = ref<boolean>(false);
    // 工地文字 true打开 false为 关闭
    const buildFlag = ref<boolean>(false);
    // 工地所有列表数据
    const buildAllData = ref<any>([]);
    // 是否显示标记图层
    const drawVisible = ref<boolean>(false);
    // 传递给标记层的数据
    const entityData = ref<any>();
    const osdVisible = computed(() => {
      return store?.state.osdVisible;
    });
    // 鼠标标记
    const plotDrawTool = ref<any>();
    // 切换地图与视频的大小 false为地图为100% true 为视频500
    const switchVedio = ref<boolean>(false);
    // 视频小盒子显示隐藏， 默认true 显示
    const shrinkVedio = ref<boolean>(false);
    // 地图切换到小盒子时，切换到哪个视频盒子里
    const mapNum = ref<number>(0);
    // 地图小盒子显示隐藏， 默认true 显示
    const shrinkMap = ref<boolean>(true);
    // 控制键盘 显示隐藏， 默认true 显示
    const shrinkControl = ref<boolean>(true);
    const waypoint = ref([]) as any;
    // 机场sn
    const checkDockSn = ref<string>("");
    // 飞机 sn
    const checkPlaneSn = ref<string>("");
    // 手控消息提示
    const controlStatusMessage = ref<any>({});
    // 是否获取控制器，true为获取控制器，false没有
    const flightControllerFlag = ref<boolean>(false);
    // 地图倾斜角度，true为地图倾斜，false地图不倾斜
    const mappitchFlag = ref<any>(false);
    // 地图设置目标点，默认false不可以点击设置，true可以设置
    const mapclickFlag = ref<boolean>(false);
    // 默认图层数据列表
    const layersOneArr = ref<any>([]);
    const checkList = ref<any>([]); //左上复选框选中的值
    let frustumMap = null as any; // 视锥体辅助地图实例
    const isfrustumMapFlag = ref(true); // 是否开启视锥体
    const maperrorFlag = ref(false); // 地图错误弹框
    const mapcompassInfo = reactive({
      angle: 0, // 角度
    }); // 指南针数据
    // 地图默认参数
    const mapSysData = reactive({
      maps: 1, //地图来源 1为cesium 2 为星图 3 为自有
      mapsxyz: [
        {
          maps: 1, //cesium
          lng: 0,
          lat: 0,
          height: 0,
        },
        {
          maps: 2, //星图
          lng: 0,
          lat: 0,
          height: 0,
        },
        {
          maps: 3, //自有
          lng: 0,
          lat: 0,
          height: 0,
        },
        {
          maps: 4, //mapbox
          lng: 0,
          lat: 0,
          height: 0,
        },
      ] as any, //不同来源对应的经纬度，高度偏差
    });
    const stopWatchList = ref<any>([]); // 停止 watch
    const deviceinfoObj = ref<any>({});
    // stopWatchList.value.push(
    watch(
      () => props.deviceInfos,
      (datas) => {
        if (datas) {
          deviceinfoObj.value = datas;
        } else {
          deviceinfoObj.value = {};
        }
      },
      { deep: true, immediate: true }
    );
    // );
    // stopWatchList.value.push(
    watch(
      () => props.checkDockSn,
      (datas) => {
        if (datas) {
          // 清除视锥体
          deviceTsaUpdateHook && deviceTsaUpdateHook.clearFrustum();
          checkDockSn.value = datas;
          mapclickFlag.value = true;
          setMapClick();
        }
      },
      { deep: true }
    );
    // );
    // stopWatchList.value.push(
    watch(
      () => mapclickFlag.value,
      (datas) => {
        setTimeout(() => {
          if (checkDockSn.value) {
            setMapClick();
          }
        }, 1000);
      },
      {
        deep: true,
      }
    );
    // );
    // 设置地图是否可以点击设置目标点
    function setMapClick() {
      const datas = mapclickFlag.value;
      const handler = root.$handler;
      // return
      if (datas) {
        if (!handler) {
          return;
        }
        handler.setInputAction(
          showInfoClick,
          Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK
        );
        handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
      } else {
        handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
        handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
        clearTxt();
        localStorage.setItem("LNG", "");
        localStorage.setItem("LAT", "");
        localStorage.setItem("ASLHEIGHT", "");
      }
    }
    // 选择飞机的sn
    // stopWatchList.value.push(
    watch(
      () => props.checkPlaneSn,
      (datas) => {
        if (datas) {
          checkPlaneSn.value = datas;
        }
      },
      { deep: true }
    );
    // );
    // 在线机场的视频数据，机场的sn、飞机的sn、负载控制
    const onlineVedioData = ref<any>([]);
    // 监听左边的机场设备
    // stopWatchList.value.push(
    watch(
      () => props.onlineDocks,
      (data) => {
        if (onlineVedioData.value.length > 0) {
          return;
        }
        onlineVedioData.value = [];
        if (data && data.length > 0) {
          data.map((item: any) => {
            onlineVedioData.value.push({
              dockSn: item?.gateway?.sn, //机场sn
              planSn: item?.sn, //飞机sn
              payloads: item.payload, //飞机负载控制
              isShow: false, //是否显示视频框
              title: item?.gateway?.callsign, //机场名称
              dockStatus: item.status, //机场状态
              planStatus: -1, //飞机状态
              bottomNum: 0, //视频框距离底部的距离
            });
          });
        }
      },
      {
        deep: true,
      }
    );
    // );
    stopWatchList.value.push(
      watch(
        () => store?.state.deviceStatusEvent,
        (data) => {
          if (Object.keys(data.deviceOnline).length !== 0) {
            store.state.deviceStatusEvent.deviceOnline = {} as DeviceStatus;
          }
          if (Object.keys(data.deviceOffline).length !== 0) {
            deviceTsaUpdateHook.removeMarker(data.deviceOffline.sn);
            if (
              data.deviceOffline.sn === osdVisible.value.sn ||
              (osdVisible.value.is_dock &&
                data.deviceOffline.sn === osdVisible.value.gateway_sn)
            ) {
              osdVisible.value.visible = false;
              store.commit("SET_OSD_VISIBLE_INFO", osdVisible);
            }
            store.state.deviceStatusEvent.deviceOffline = {};
          }
        },
        {
          deep: true,
        }
      )
    );
    const positions = ref<any>([]);
    // 机场坐标
    const dockPosition = ref<any>([]);
    const workspaceId = ref(
      localStorage.getItem(ELocalStorageKey.WorkspaceId)!
    );
    // 获取所有设备
    function getAllDevice() {
      getDeviceTopo(workspaceId.value).then((res) => {
        if (res.code !== 0) {
          return;
        }
        devicesAll.data = res.data;
      });
    }
    // 地图图层 1 为cesium， 2为星图  3为 自有
    const layerVisible = ref<number>(1);
    // 切换图层时清空覆盖物
    async function clearMapLayer() {
      mapSysData.maps = layerVisible.value;
      const mark = store?.state.markerInfo.coverMap;
      if (!mark) {
        return;
      }
      for (const key in mark) {
        deviceTsaUpdateHook.removeMarker(key);
      }
      buildFlag.value = false;
      buildSwitch.value = false;
      closeBuild();
    }
    // 自有图层
    async function starandLayer() {
      const mapinstancegmap = root.$mapinstancegmap;
      const TDT_SL = new Cesium.UrlTemplateImageryProvider({
        url: mapUrlList.own_imgurl,
        minimumLevel: 3,
        maximumLevel: 19,
        type: "xyz",
      });
      // 切换高程
      const terrainProvider2 = new Cesium.CesiumTerrainProvider({
        url: mapUrlList.own_treeain,
      });
      layerVisible.value = 3;
      clearMapLayer();
      mapinstancegmap.viewer.imageryLayers.removeAll();
      mapinstancegmap.viewer.imageryLayers.addImageryProvider(TDT_SL);
      mapinstancegmap.viewer.terrainProvider = terrainProvider2;
      setTimeout(() => {
        // 工地标记是否打开
        getBuildFlag();
        // 标记
        resetDraws();
      }, 1000);
    }
    // 星球图层
    async function starandLayerXin() {
      const mapinstancegmap = root.$mapinstancegmap;
      // await clearMapLayer()
      // 瓦片 图层
      const TDT_SL = new Cesium.UrlTemplateImageryProvider({
        url: mapUrlList.xin_imgUrl,
        minimumLevel: 3,
        maximumLevel: 22,
        type: "xyz",
      });
      // 高程
      const terrainProvider1 = new Cesium.CesiumTerrainProvider({
        url: mapUrlList.xin_treeain,
      });
      layerVisible.value = 2;
      clearMapLayer();
      mapinstancegmap.viewer.imageryLayers.removeAll();
      mapinstancegmap.viewer.imageryLayers.addImageryProvider(TDT_SL);
      mapinstancegmap.viewer.terrainProvider = terrainProvider1;
      setTimeout(() => {
        // 工地标记是否打开
        getBuildFlag();
        // 标记
        resetDraws();
      }, 1000);
    }
    // 卫星图层
    async function starLayer() {
      const mapinstancegmap = root.$mapinstancegmap;
      // await clearMapLayer()
      layerVisible.value = 1;
      const TDT_SLs = new Cesium.WebMapTileServiceImageryProvider({
        url: mapUrlList.ces_imgurl1,
        // url: "https://t0.tianditu.gov.cn/DataServer?T=img_w&X={x}&Y={y}&L={z}",
        layer: "cva",
        style: "default",
        format: "tiles",
        tileMatrixSetID: "w",
        subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
        maximumLevel: 18,
      });
      const imgs = new Cesium.WebMapTileServiceImageryProvider({
        url: mapUrlList.ces_imgurl2,
        layer: "img",
        style: "default",
        format: "tiles",
        tileMatrixSetID: "w",
        subdomains: ["t0", "t1", "t2", "t3", "t4", "t5", "t6", "t7"],
        maximumLevel: 18,
      });
      clearMapLayer();
      mapinstancegmap.viewer.imageryLayers.removeAll();
      mapinstancegmap.viewer.imageryLayers.addImageryProvider(TDT_SLs);
      mapinstancegmap.viewer.imageryLayers.addImageryProvider(imgs);
      // 切换回默认的高程
      mapinstancegmap.viewer.terrainProvider = Cesium.createWorldTerrain({
        requestVertexNormals: false,
        requestWaterMask: false,
      });
      setTimeout(() => {
        // 工地标记是否打开
        getBuildFlag();
        // 标记
        resetDraws();
      }, 1000);
    }
    // mapbox 图层
    function starLayerMapbox() {
      const mapinstancegmap = root.$mapinstancegmap;
      layerVisible.value = 4;
      // 4 mapbox
      const mapboxLayer = new Cesium.UrlTemplateImageryProvider({
        url: mapUrlList.mapbox_imgurl,
        minimumLevel: 3,
        maximumLevel: 22,
        type: "xyz",
      });
      clearMapLayer();
      mapinstancegmap.viewer.imageryLayers.removeAll();
      mapinstancegmap.viewer.imageryLayers.addImageryProvider(mapboxLayer);
      // 切换回默认的高程
      mapinstancegmap.viewer.terrainProvider = Cesium.createWorldTerrain({
        requestVertexNormals: false,
        requestWaterMask: false,
      });
      setTimeout(() => {
        // 工地标记是否打开
        getBuildFlag();
        // 标记
        resetDraws();
      }, 1000);
    }
    const isShowLayer = ref<boolean>(false);
    function showLayer() {
      isShowLayer.value = true;
    }
    function hideLayer() {
      isShowLayer.value = false;
    }
    const flysucesswayline = ref<boolean>(false);
    // 一键起飞成功后，地图不能再选点 绘制航线
    function cancalemapclick(val: any) {
      // console.log(3556,val);
      flysucesswayline.value = val;
    }
    stopWatchList.value.push(
      watch(
        () => store?.state.deviceState,
        (data: any) => {
          // console.log(1095,data,data.currentSn);

          // 遥控器
          if (
            data.currentType === EDeviceTypeName.Gateway &&
            data.gatewayInfo[data.currentSn]
          ) {
            deviceTsaUpdateHook.moveTo(
              data.currentSn,
              data.gatewayInfo[data.currentSn].longitude,
              data.gatewayInfo[data.currentSn].latitude
            );
          }
          // 飞机
          if (
            data.currentType === EDeviceTypeName.Aircraft &&
            data.deviceInfo[data.currentSn]
          ) {
            let gimbals = 0; // 飞机偏航角
            let pitch = 0; // 飞机俯仰角
            let yaw = 0; // 飞机偏航角
            const planCode = data.deviceInfo[data.currentSn].mode_code; // 飞机状态 0为离线 3为手控，7为航线中 5为航线点 2准备中，10着路 9返航
            if (
              data.deviceInfo[data.currentSn].payloads &&
              data.deviceInfo[data.currentSn].payloads.length > 0
              // && data.deviceInfo[data.currentSn].payloads[0].gimbal_yaw
            ) {
              const yawD =
                data.deviceInfo[data.currentSn].payloads[0].gimbal_yaw - 0; //data.deviceInfo[data.currentSn].attitude_head
              const pitchD =
                data.deviceInfo[data.currentSn].payloads[0].gimbal_pitch || 0;
              if (yawD) {
                yaw = Number(Number(yawD).toFixed(1));
              }
              if (pitchD) {
                pitch = Number(Number(pitchD).toFixed(1));
              }
              // gimbals = data.deviceInfo[data.currentSn].payloads[0].gimbal_yaw || 0;
              gimbals = yaw;
            }
            if (pitch >= 45) {
              pitch = 45;
            }
            if (pitch <= -120) {
              pitch = -120;
            }
            // console.log(1140,yaw,pitch, data.deviceInfo[data.currentSn].payloads[0].gimbal_yaw , data.deviceInfo[data.currentSn].attitude_head);
            if (onlineVedioData.value && onlineVedioData.value.length > 0) {
              const num = props.checkDockNum ? props.checkDockNum : 0;
              const planeSn = onlineVedioData.value[num].planSn;
              if (planeSn == data.currentSn) {
                // 只要飞机的垂直速度或水平速度存在时，飞机移动
                const vertical_speed =
                  data.deviceInfo[data.currentSn]?.vertical_speed;
                const horizontal_speed =
                  data.deviceInfo[data.currentSn]?.horizontal_speed;
                if (
                  (vertical_speed && Number(vertical_speed) != 0) ||
                  (horizontal_speed && Number(horizontal_speed) != 0)
                ) {
                  // 只有选中当前机场，飞机才移动
                  const ht = safeParseFloat(
                    parseFloat(data.deviceInfo[data.currentSn].height) +
                      mapSysData.mapsxyz[mapSysData.maps - 1].height
                  );
                  const lng = safeParseFloat(
                    data.deviceInfo[data.currentSn].longitude +
                      mapSysData.mapsxyz[mapSysData.maps - 1].lng
                  );
                  const lat = safeParseFloat(
                    data.deviceInfo[data.currentSn].latitude +
                      mapSysData.mapsxyz[mapSysData.maps - 1].lat
                  );
                  if (lng && lat && ht) {
                    const points1 = isValidArray([lng, lat, ht]);
                    if (points1 && points1.length > 0) {
                      deviceTsaUpdateHook.moveTo(
                        data.currentSn,
                        points1[0],
                        points1[1],
                        points1[2],
                        gimbals
                      );
                    }
                  }
                  // 存在普通航线飞行
                  if (props.wayStatus) {
                    if (
                      data.deviceInfo[data.currentSn].longitude > 0 &&
                      data.deviceInfo[data.currentSn].latitude > 0
                    ) {
                      const lng1 = safeParseFloat(
                        data.deviceInfo[data.currentSn].longitude +
                          mapSysData.mapsxyz[mapSysData.maps - 1].lng
                      );
                      const lat1 = safeParseFloat(
                        data.deviceInfo[data.currentSn].latitude +
                          mapSysData.mapsxyz[mapSysData.maps - 1].lat
                      );
                      if (lng1 && lat1 && ht) {
                        const point = isValidArray([lng1, lat1, ht]);
                        if (point && point.length > 0) {
                          waypoint.value.push(point);
                          waylineDraw(waypoint.value);
                        }
                      }
                    }
                  } else if (flysucesswayline.value) {
                    // 一键起飞成功
                    if (
                      data.deviceInfo[data.currentSn].longitude > 0 &&
                      data.deviceInfo[data.currentSn].latitude > 0
                    ) {
                      const lng2 = safeParseFloat(
                        data.deviceInfo[data.currentSn].longitude +
                          mapSysData.mapsxyz[mapSysData.maps - 1].lng
                      );
                      const lat2 = safeParseFloat(
                        data.deviceInfo[data.currentSn].latitude +
                          mapSysData.mapsxyz[mapSysData.maps - 1].lat
                      );
                      if (lng2 && lat2 && ht) {
                        const point = isValidArray([lng2, lat2, ht]);
                        if (point && point.length > 0) {
                          flyAimData.value.push(point);
                          waylineFly(flyAimData.value);
                        }
                      }
                    }
                  }
                } else {
                  // 飞机垂直速度、水平速度为0 或者不存在时，只绘制飞机的图标
                  const hts = safeParseFloat(
                    parseFloat(data.deviceInfo[data.currentSn].height) +
                      mapSysData.mapsxyz[mapSysData.maps - 1].height
                  );
                  const lng3 = safeParseFloat(
                    data.deviceInfo[data.currentSn].longitude +
                      mapSysData.mapsxyz[mapSysData.maps - 1].lng
                  );
                  const lat3 = safeParseFloat(
                    data.deviceInfo[data.currentSn].latitude +
                      mapSysData.mapsxyz[mapSysData.maps - 1].lat
                  );
                  if (lng3 && lat3 && hts) {
                    const points = isValidArray([lng3, lat3, hts]);
                    if (points && points.length > 0) {
                      // console.log(1249);
                      // 绘制机场图标
                      deviceTsaUpdateHook.initMarker(
                        EDeviceTypeName.Aircraft,
                        [EDeviceTypeName.Aircraft],
                        data.currentSn,
                        points
                      );
                    }
                  }
                }
                // 3为手控，7为航线中 5为航线点 2准备中，10着路 9返航 "17":"指令飞行"
                if (
                  planCode == 3 ||
                  planCode == 5 ||
                  planCode == 7 ||
                  planCode == 9 ||
                  planCode == 10 ||
                  planCode == 17
                ) {
                  const ht = safeParseFloat(
                    parseFloat(data.deviceInfo[data.currentSn].height) +
                      mapSysData.mapsxyz[mapSysData.maps - 1].height
                  );
                  const lng = safeParseFloat(
                    data.deviceInfo[data.currentSn].longitude +
                      mapSysData.mapsxyz[mapSysData.maps - 1].lng
                  );
                  const lat = safeParseFloat(
                    data.deviceInfo[data.currentSn].latitude +
                      mapSysData.mapsxyz[mapSysData.maps - 1].lat
                  );
                  if (lng && lat && ht) {
                    const points1 = isValidArray([lng, lat, ht]);
                    if (points1 && points1.length > 0) {
                      // 视锥体
                      if (isfrustumMapFlag.value && frustumMap) {
                        const pitchValue = Number(Number(pitch).toFixed(1));
                        const yawValue = Number(Number(yaw).toFixed(1));
                        // console.log(yawValue,'yawValue');

                        frustumMap.camera.setView({
                          orientation: {
                            heading: Cesium.Math.toRadians(yawValue),
                            pitch: Cesium.Math.toRadians(pitchValue),
                            roll: 0,
                          },
                        });
                        const mapinstancegmap = root.$mapinstancegmap;
                        if (mapinstancegmap && mapinstancegmap.viewer) {
                          const params = {
                            lng: points1[0],
                            lat: points1[1],
                            height: points1[2],
                            mapviewer: frustumMap,
                            viewer: mapinstancegmap.viewer,
                          };
                          deviceTsaUpdateHook.initFrustum(params);
                        }
                      }
                    }
                  }
                } else {
                  // 清除视锥体
                  deviceTsaUpdateHook.clearFrustum();
                }
              }
            }
          }
          // 机场
          if (
            data.currentType === EDeviceTypeName.Dock &&
            data.dockInfo[data.currentSn] &&
            data.dockInfo[data.currentSn].basic_osd
          ) {
            positions.value = [];
            dockPosition.value = [];
            // 机场返回的经纬度存在
            if (
              data.dockInfo[data.currentSn].basic_osd &&
              data.dockInfo[data.currentSn].basic_osd.longitude &&
              data.dockInfo[data.currentSn].basic_osd.longitude != 0 &&
              data.dockInfo[data.currentSn].basic_osd.latitude &&
              data.dockInfo[data.currentSn].basic_osd.latitude != 0
            ) {
              // console.log(12222,mapSysData.mapsxyz[mapSysData.maps - 1]);

              const heighss = safeParseFloat(
                Number(data.dockInfo[data.currentSn].basic_osd.height || 500) +
                  mapSysData.mapsxyz[mapSysData.maps - 1].height || 0
              );
              const lngs = safeParseFloat(
                data.dockInfo[data.currentSn].basic_osd.longitude +
                  mapSysData.mapsxyz[mapSysData.maps - 1].lng
              );
              const lats = safeParseFloat(
                data.dockInfo[data.currentSn].basic_osd.latitude +
                  mapSysData.mapsxyz[mapSysData.maps - 1].lat
              );
              if (lngs && lats && heighss) {
                const pos = isValidArray([lngs, lats, heighss]);
                if (pos && pos.length > 0) {
                  positions.value = pos;
                  if (data.currentSn == checkDockSn.value) {
                    dockPosition.value = pos;
                  }
                }
              }
            } else {
              if (devicesAll.data.length == 0) {
                return;
              }
              devicesAll.data.map((item: any) => {
                if (item.device_sn == data.currentSn) {
                  if (
                    safeParseFloat(item.longitude) &&
                    safeParseFloat(item.latitude)
                  ) {
                    positions.value = isValidArray([
                      safeParseFloat(item.longitude),
                      safeParseFloat(item.latitude),
                      safeParseFloat(item.osd_height) || 500,
                    ]);
                    // console.log(6188, positions.value);
                    if (data.currentSn == checkDockSn.value) {
                      dockPosition.value = isValidArray([
                        safeParseFloat(item.longitude),
                        safeParseFloat(item.latitude),
                      ]);
                    }
                  } else {
                    positions.value = [104.092518, 30.654566, 500];
                    if (data.currentSn == checkDockSn.value) {
                      dockPosition.value = [104.092518, 30.654566];
                    }
                  }
                }
              });
            }
            // 绘制机场图标
            if (positions.value && positions.value.length > 0) {
              deviceTsaUpdateHook.initMarker(
                EDeviceTypeName.Dock,
                [EDeviceTypeName.Dock],
                data.currentSn,
                positions.value,
                checkDockSn.value,
                dockPosition.value
              );
            }
          }
        },
        {
          deep: true,
        }
      )
    );
    stopWatchList.value.push(
      watch(
        () => store?.state.wsEvent,
        (newData) => {
          const event = newData;
          let exist = false;
          if (Object.keys(event.mapElementCreat).length !== 0) {
            // console.log(event.mapElementCreat);
            const ele = event.mapElementCreat as any;
            store.state.Layers.forEach((layer) => {
              layer.elements.forEach((e: any) => {
                if (e.id === ele.id) {
                  exist = true;
                  // console.log("true");
                }
              });
            });
            if (exist === false) {
              setLayers({
                id: ele.id,
                name: ele.name,
                resource: ele.resource,
              });

              updateCoordinates("wgs84-gcj02", ele);
            }

            store.state.wsEvent.mapElementCreat = {};
          }
          if (Object.keys(event.mapElementUpdate).length !== 0) {
            // console.log(event.mapElementUpdate);
            // console.log("该功能还未实现，请开发商自己增加");
            store.state.wsEvent.mapElementUpdate = {};
          }
          if (Object.keys(event.mapElementDelete).length !== 0) {
            // console.log(event.mapElementDelete);
            // console.log("该功能还未实现，请开发商自己增加");
            store.state.wsEvent.mapElementDelete = {};
          }
        },
        {
          deep: true,
        }
      )
    );
    const waypointline = ref(null);
    // 手动控制目标点的航线
    const waypointlineFly = ref(null);
    // 手动控制 绘制折线轨迹的数据
    const flyData = ref<any>([]);
    // 手动控制 绘制飞向目标点折线轨迹的数据
    const flyAimData = ref<any>([]);
    // 已执行航线 只执行一次
    const overPathOne = ref<number>(0);
    const markerList = reactive({
      data: [] as any,
      onePoint: [] as any,
      textOne: [] as any,
      line: [] as any, //虚线
      lineway: [] as any, //目标点的航线
      wayline: [] as any, // 初始化的航线
      waylineover: [] as any, // 航线 已执行的航线
    });
    const devicesAll = reactive({
      data: [] as any,
    });
    // hangx
    // const wayNum = ref<number>(0)
    // stopWatchList.value.push(
    watch(
      () => props.wayStatus,
      (datas) => {
        if (datas) {
          if (props.wayPath && props.wayPath.length > 0) {
            initWayline(props.wayPath);
          }
        } else {
          if (root.$mapinstancegmap) {
            if (markerList.data.length > 0) {
              markerList.data.map((item: any) => {
                item.destroy();
              });
            }
            if (markerList.line.length > 0) {
              markerList.line.map((item: any) => {
                item.destroy();
              });
            }
            if (markerList.lineway.length > 0) {
              markerList.lineway.map((item: any) => {
                item.destroy();
              });
            }
            // 清除初始化的航线
            if (markerList.wayline.length > 0) {
              markerList.wayline.map((item: any) => {
                item.destroy();
              });
              markerList.wayline = [];
            }
            // 清除已执行的航线
            if (markerList.waylineover.length > 0) {
              markerList.waylineover.map((item: any) => {
                item.destroy();
              });
            }
          }
        }
      },
      { deep: true }
    );
    // );

    // 点击上方的飞行控制后，地图可以设置目标点
    function mapclick(val: any) {
      mapclickFlag.value = val;
    }
    // 刷新后
    function aimpoints(datas: any) {
      if (datas && datas.length > 0) {
        const handler = root.$handler;
        handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
        handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
        handler.setInputAction(
          rightMap,
          Cesium.ScreenSpaceEventType.RIGHT_CLICK
        );
        flyData.value = [];
        datas.map((item: any, index: any) => {
          if (item.latitude && item.longitude) {
            const height = item.height - item.manual_height;
            if (
              safeParseFloat(item.longitude) &&
              safeParseFloat(item.latitude) &&
              safeParseFloat(height)
            ) {
              const arr = [
                safeParseFloat(item.longitude),
                safeParseFloat(item.latitude),
                safeParseFloat(height),
              ];
              mapAimPoint(arr, index + 1);
              flyData.value.push(arr);
            }
          }
        });
      }
    }
    // 刷新后
    // stopWatchList.value.push(
    watch(
      () => props.aimpoint,
      (datas) => {
        if (datas && datas.length > 0) {
          const handler = root.$handler;
          handler.removeInputAction(Cesium.ScreenSpaceEventType.MOUSE_MOVE);
          handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
          handler.setInputAction(
            rightMap,
            Cesium.ScreenSpaceEventType.RIGHT_CLICK
          );
          flyData.value = [];
          datas.map((item: any, index: any) => {
            if (item.latitude && item.longitude) {
              const height = item.height - item.manual_height;
              if (
                safeParseFloat(item.longitude) &&
                safeParseFloat(item.latitude) &&
                safeParseFloat(height)
              ) {
                const arr = [
                  safeParseFloat(item.longitude),
                  safeParseFloat(item.latitude),
                  safeParseFloat(height),
                ];
                mapAimPoint(arr, index + 1);
                flyData.value.push(arr);
              }
            }
          });
        }
      },
      {
        deep: true,
      }
    );
    // );
    // 飞行控制轨迹
    function aircraftpositionings(datas: any) {
      if (datas && datas.length > 0) {
        flyAimData.value = [];
        // console.log(1372,datas);
        datas.map((item: any) => {
          if (item.lon && item.lat) {
            const lng = safeParseFloat(item.lon);
            const lat = safeParseFloat(item.lat);
            const height = safeParseFloat(item.height);
            if (lng && lat && height) {
              flyAimData.value.push([lng, lat, height]);
            }
          }
        });
        waylineFly(flyAimData.value);
      }
    }
    // 机场 飞机均为空闲时将地图上的目标点清除掉
    function cleardata(val: boolean) {
      if (!val) {
        const handler = root.$handler;
        if (handler) {
          clearTxt();
          if (markerList.onePoint.length > 0) {
            markerList.onePoint.map((item: any) => {
              item.destroy();
            });
          }
          if (markerList.line.length > 0) {
            markerList.line.map((item: any) => {
              item.destroy();
            });
          }
          if (markerList.lineway.length > 0) {
            markerList.lineway.map((item: any) => {
              item.destroy();
            });
          }
          handler.setInputAction(
            showInfoClick,
            Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK
          );
          handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
          if (waypointlineFly.value) {
            root.$mapinstancegmap.viewer.scene.primitives.remove(
              waypointlineFly.value
            );
          }
        }
      }
    }
    // 清除地图上的目标点
    // stopWatchList.value.push(
    watch(
      () => props.clearmapaim,
      (val) => {
        if (!val) {
          const handler = root.$handler;
          if (handler) {
            clearTxt();
            if (markerList.onePoint.length > 0) {
              markerList.onePoint.map((item: any) => {
                item.destroy();
              });
            }
            if (markerList.line.length > 0) {
              markerList.line.map((item: any) => {
                item.destroy();
              });
            }
            if (markerList.lineway.length > 0) {
              markerList.lineway.map((item: any) => {
                item.destroy();
              });
            }
            handler.setInputAction(
              showInfoClick,
              Cesium.ScreenSpaceEventType.LEFT_DOUBLE_CLICK
            );
            handler.removeInputAction(Cesium.ScreenSpaceEventType.RIGHT_CLICK);
            if (waypointlineFly.value) {
              root.$mapinstancegmap.viewer.scene.primitives.remove(
                waypointlineFly.value
              );
            }
          }
        }
      },
      {
        deep: true,
      }
    );
    // );
    // 当飞机为手控\航线点时 地图右键可以点击
    function rightclick(val: any) {
      if (val) {
        const handler = root.$handler;
        if (handler) {
          handler.setInputAction(
            rightMap,
            Cesium.ScreenSpaceEventType.RIGHT_CLICK
          );
        }
      }
    }
    // 地图右键点击事件
    // stopWatchList.value.push(
    watch(
      () => props.flysucessrightclick,
      (val) => {
        if (val) {
          const handler = root.$handler;
          if (handler) {
            handler.setInputAction(
              rightMap,
              Cesium.ScreenSpaceEventType.RIGHT_CLICK
            );
          }
        }
      },
      {
        deep: true,
      }
    );
    // );
    // 已执行的航线
    // stopWatchList.value.push(
    watch(
      () => props.overwayPath,
      (datas: any) => {
        if (datas && datas.length > 0) {
          // waylineDraw(datas);
          waypoint.value = datas;
          waylineDraw(waypoint.value);
        }
      },
      { deep: true }
    );
    // );
    // 传递给视频面板的参数
    const toVedioDatas = ref<any>();
    // 获取控制面板传递给视频面板的参数
    function toVedio(data: any) {
      toVedioDatas.value = data;
    }
    // 获取距离
    function getDistance(satrt: any, end: any) {
      let startPosition = Cesium.Cartesian3.fromDegrees(
        satrt[0],
        satrt[1],
        satrt[2]
      );
      let endPosition = Cesium.Cartesian3.fromDegrees(end[0], end[1], end[2]);
      return Cesium.Cartesian3.distance(startPosition, endPosition);
    }
    // 用两个点来画线，不用所有点的集合来画线
    async function twoLine(newArr: any) {
      // distance 为海拔高度
      let distance = await getDistance(newArr[0], newArr[1]);
      if (judgeArrNaN(newArr)) {
        try {
          let primitiveLine = new et.graphic.PolylinePrimitive({
            positions: newArr,
            style: {
              width: 10,
              material: et.MaterialUtil.createMaterial(et.MaterialType.Image, {
                image: Arrow,
                repeat: new Cesium.Cartesian2(
                  Number(distance / 40).toFixed(0),
                  1
                ),
                color: new Cesium.Color(0 / 255, 213 / 255, 143 / 255),
              }),
            },
          });
          markerList.wayline.push(primitiveLine);
          root.$theLayergmap.addGraphic(primitiveLine);
        } catch (error) {
          console.log("twoLine：", error);
        }
      }
    }
    // 初始化航线
    async function initWayline(data: any) {
      const datas = isValidArray(data);
      if (datas && datas.length > 0) {
        let a = JSON.parse(JSON.stringify(datas));
        if (a && a.length > 0) {
          // 画线
          if (a.length > 1) {
            // a 中包含四个参数，经度、纬度、海拔高度、相对地面高度，画线需要将海拔高度加上相对地面高度
            let newArr = [] as any;
            a.map((item: any) => {
              if (item.length == 4) {
                item[2] = safeParseFloat(parseInt(item[2]) + parseInt(item[3]));
              }
              if (
                safeParseFloat(item[0]) &&
                safeParseFloat(item[1]) &&
                safeParseFloat(item[2])
              ) {
                newArr.push([
                  safeParseFloat(item[0]),
                  safeParseFloat(item[1]),
                  safeParseFloat(item[2]),
                ]);
              }
            });
            // 用两点来画线，不用所有的点来画线
            let result = [];
            for (let i = 0; i < newArr.length - 1; i++) {
              if (newArr[i] && newArr[i + 1]) {
                result.push([newArr[i], newArr[i + 1]]);
              }
            }
            result.forEach((item: any) => {
              twoLine(item);
            });
          }
          //--画三角形
          initWayMarker(JSON.parse(JSON.stringify(datas)));
        }
      }
    }
    // 绘制已执行航线轨迹
    async function waylineDraw(datas: any) {
      // console.log("708航线轨迹", data);
      // 检查数组长度是否超过JavaScript的最大长度限制
      if (datas.length >= Math.pow(2, 32)) {
        console.log(
          "绘制已执行航线轨迹gmap,数组长度超过JavaScript的最大长度限制！"
        );
        message.error(
          "绘制已执行航线轨迹gmap,数组长度超过JavaScript的最大长度限制！"
        );
      }
      const data = isValidArray(datas);
      if (data && data.length > 0) {
        const theLayergmap = root.$theLayergmap;
        if (theLayergmap.graphics.length > 1 && data.length > 1) {
          if (judgeArrNaN(data)) {
            try {
              waypointline.value = new et.graphic.PolylinePrimitive({
                positions: data,
                style: {
                  width: 1.5,
                  material: et.MaterialUtil.createMaterial(
                    et.MaterialType.Color,
                    {
                      color: new Cesium.Color.fromCssColorString("#3366FF"),
                    }
                  ),
                },
              });
              theLayergmap.addGraphic(waypointline.value);
              markerList.waylineover.push(waypointline.value);
            } catch (error) {
              console.log("waylineDraw：", error);
            }
          }
        }
      }
    }
    // 绘制手动控制飞向某点的轨迹
    async function waylineFly(datas: any) {
      const data = isValidArray(datas);
      if (data && data.length > 0) {
        const theLayergmap = root.$theLayergmap;
        if (theLayergmap.graphics.length > 1 && data.length > 1) {
          if (data) {
            if (judgeArrNaN(data)) {
              try {
                waypointlineFly.value = new et.graphic.PolylinePrimitive({
                  positions: data,
                  style: {
                    width: 1.5,
                    material: et.MaterialUtil.createMaterial(
                      et.MaterialType.Color,
                      {
                        color: new Cesium.Color.fromCssColorString("#3366FF"),
                      }
                    ),
                  },
                });
                theLayergmap.addGraphic(waypointlineFly.value);
                markerList.lineway.push(waypointlineFly.value);
              } catch (error) {
                console.log("waylineFly:", error);
              }
            }
          }
        }
      }
    }
    // 画三角形
    function initWayMarker(data: any) {
      let a1 = data;
      const theLayer = root.$theLayergmap;
      let newArr = [] as any;
      a1.map((item: any) => {
        if (item.length == 4) {
          item[2] = safeParseFloat(parseInt(item[2]) + parseInt(item[3]));
        }
        if (
          safeParseFloat(item[0]) &&
          safeParseFloat(item[1]) &&
          safeParseFloat(item[2])
        ) {
          newArr.push([
            safeParseFloat(item[0]),
            safeParseFloat(item[1]),
            safeParseFloat(item[2]),
          ]);
        }
      });
      const newArrs = isValidArray(newArr);
      if (newArrs && newArrs.length > 0) {
        newArrs.forEach((item: any, index: number) => {
          if (judgeArrNaN(item)) {
            try {
              // 画点
              let pointPrimitive = new et.graphic.PointPrimitive({
                position: item,
                index: index,
                style: {
                  pixelSize: 0,
                  // color: Cesium.Color.fromCssColorString("#31abe1").withAlpha(1),
                  label: {
                    text: String(index + 1),
                    visibleDepth: false,
                    font_weight: true,
                    backgroundColor: Cesium.Color.fromCssColorString("#31abe1"),
                    backgroundPadding: new Cesium.Cartesian2(7, 5),
                    background: true,
                  },
                },
              });
              theLayer.addGraphic(pointPrimitive);
              generateDashLine(item, a1[index][3]); //生成 虚线 的方法
              markerList.data.push(pointPrimitive);
            } catch (error) {
              console.log("initWayMarker:", error);
            }
          }
        });
      }
    }
    // 点到地面之间的虚线
    function generateDashLine(pos: any, referenceHeight: any) {
      let pointBottom = [pos[0], pos[1], pos[2] - referenceHeight];
      // console.log("pointbootom", pointBottom);
      if (judgeArrNaN([pointBottom, pos])) {
        try {
          let primitiveLine = new et.graphic.PolylinePrimitive({
            positions: [pointBottom, pos],
            style: {
              width: 2,
              materialType: et.MaterialType.PolylineDash, //虚线
              dashLength: 10,
              color: Cesium.Color.WHITE,
            },
          });
          root.$theLayergmap.addGraphic(primitiveLine);
          markerList.line.push(primitiveLine);
        } catch (error) {
          console.log("generateDashLine:", error);
        }
      }
    }
    // 地图鼠标移动 当点了点后，不显示
    const textshow = ref<boolean>(true);
    // 是否鼠标左键双击可以打点 当打开无人机操作（true）时，可以打点,否则不可以
    const doubleClickFlag = ref<boolean>(false);
    function leftDoubleClick(val: boolean) {
      doubleClickFlag.value = val;
    }
    // 地图点击事件
    function showInfoClick(e: any) {
      flyData.value = [];
      flyAimData.value = [];
      // console.log(234000,e);
      if (!doubleClickFlag.value) {
        message.error("请先打开无人机操作");
        return;
      }
      // 鼠标点击 用position
      let pos = getLatLonAltInfo(
        root.$mapinstancegmap.viewer,
        e.position
      ) as any;
      const lng = safeParseFloat(
        parseFloat(pos[0]) - mapSysData.mapsxyz[mapSysData.maps - 1].lng
      );
      const lat = safeParseFloat(
        parseFloat(pos[1]) - mapSysData.mapsxyz[mapSysData.maps - 1].lat
      );
      const aslheight = safeParseFloat(
        parseInt(pos[2]) - mapSysData.mapsxyz[mapSysData.maps - 1].height
      );
      if (lng && lat && aslheight) {
        localStorage.setItem("LNG", lng + "");
        localStorage.setItem("LAT", lat + "");
        localStorage.setItem("ASLHEIGHT", aslheight + "");
      }
      if (markerList.onePoint.length > 0) {
        markerList.onePoint.map((item: any) => {
          item.destroy();
        });
      }
      if (markerList.line.length > 0) {
        markerList.line.map((item: any) => {
          item.destroy();
        });
      }
      if (markerList.lineway.length > 0) {
        markerList.lineway.map((item: any) => {
          item.destroy();
        });
      }
      flyData.value.push(pos);
      mapAimPoint(pos, flyData.value.length);
      if (markerList.onePoint && markerList.onePoint.length > 0) {
        clearTxt();
        textshow.value = false;
        root.$handler.removeInputAction(Cesium.ScreenSpaceEventType.LEFT_CLICK);
      }
    }
    // 地图目标点
    function mapAimPoint(pos: any, index: any) {
      let height = localStorage.getItem("HEIGHT");
      if (!height) {
        message.warn("请先输入飞行作业高度");
        return;
      }
      let newheight = 0;
      if (height) {
        const h = safeParseFloat(height) || 0;
        newheight = h;
        pos[2] += h;
      } else {
        pos[2] += 120;
        newheight = 120;
      }
      // console.log(21121, pos, newheight);
      const poss = isValidArray(pos);
      if (poss && poss.length > 0) {
        try {
          let pointPrimitive = new et.graphic.PointPrimitive({
            position: poss,
            style: {
              pixelSize: 0,
              // color: Cesium.Color.fromCssColorString("#31abe1").withAlpha(1),
              label: {
                text: String(index),
                visibleDepth: false,
                font_weight: true,
                backgroundColor: Cesium.Color.fromCssColorString("#31abe1"),
                backgroundPadding: new Cesium.Cartesian2(7, 5),
                background: true,
              },
            },
          });
          root.$theLayergmap.addGraphic(pointPrimitive);
          markerList.onePoint.push(pointPrimitive);
          generateDashLine(pos, newheight); //生成 虚线 的方法
        } catch (error) {
          console.log("mapAimPoint:", error);
        }
      }
    }
    // 添加鼠标MOUSE_MOVE事件
    function mousemove() {
      const mapinstancegmap = root.$mapinstancegmap;
      if (!mapinstancegmap) {
        return;
      }
      const handler = new Cesium.ScreenSpaceEventHandler(
        mapinstancegmap.viewer.scene.canvas
      );
      handler.setInputAction(function (evt: any) {
        if (!evt) {
          return;
        }
        let pos = getLatLonAltInfo(mapinstancegmap.viewer, evt.endPosition);
        // console.log(5776,pos);
        if (!pos) {
          return;
        }
        lonLatAlt.value[0] = pos[0].toFixed(4);
        lonLatAlt.value[1] = pos[1].toFixed(4);
        altHeight.value = pos[2].toFixed(1);
      }, Cesium.ScreenSpaceEventType.MOUSE_MOVE);
    }
    // 获取位置的方法
    function getLatLonAltInfo(viewer: any, evt: any) {
      let ray = viewer.camera.getPickRay(evt);
      let cartesian = viewer.scene.globe.pick(ray, viewer.scene);
      // console.log(5485,cartesian);
      if (!cartesian) {
        return;
      }
      let cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      let lng = safeParseFloat(Cesium.Math.toDegrees(cartographic.longitude));
      let lat = safeParseFloat(Cesium.Math.toDegrees(cartographic.latitude));
      let height = safeParseFloat(cartographic.height);
      return [lng, lat, height];
    }
    // 清除文字
    function clearTxt() {
      if (markerList.textOne && markerList.textOne.length > 0) {
        markerList.textOne.map((item: any) => {
          if (item) {
            item.destroy();
          }
        });
      }
    }
    const contextMenuPositon = ref<any>(null);
    const { flyToPoint } = useDroneControl();
    // 飞到某处的,飞行控制的方法
    async function onFlyToConfirm(
      confirm: boolean,
      lng: any,
      lat: any,
      aslheight: any
    ) {
      const height = localStorage.getItem("HEIGHT");
      const sn = localStorage.getItem("DOCKSN");
      if (!sn && !height) {
        return;
      }
      const flyheight = safeParseFloat(parseInt(aslheight) + Number(height));
      if (confirm && safeParseFloat(lng) && safeParseFloat(lat) && flyheight) {
        try {
          // 获取一键起飞的高度以及机场的sn
          await flyToPoint(sn, Number(height), {
            max_speed: 14,
            points: [
              {
                latitude: lat,
                longitude: lng,
                height: flyheight,
              },
            ],
          });
        } catch (error) {}
      }
    }
    // 地图右键点击事件
    function rightMap(e: any) {
      // const AMapRight = root.$aMap;
      // 鼠标点击 用position
      const viewer = root.$mapinstancegmap.viewer;
      let pos = getLatLonAltInfo(viewer, e.position);
      // 判断点击位置是否有实体
      let pickedObject = viewer.scene.pick(e.position);
      let lis = "";
      let con = "";
      let cesiumContainer = document.querySelector("#g-container") as any;
      if (!cesiumContainer) {
        return;
      }
      // console.log(2038, "rightmap", pos, pickedObject, cesiumContainer);
      if (pickedObject == undefined) {
        contextMenuPositon.value = pos;

        lis += `<li class="li-item" data-index="20">
                            <a href="#" style="border-bottom: 1px solid rgba(128, 128, 128, 0.5);
  padding: 6px 10px;
  transition: background-color 0.25s;
  display: block;
  clear: both;
  font-weight: 400;
  line-height: 1.6;
  white-space: nowrap;
  color: #edffff;
  text-decoration: none;">飞往此处</a>
                </li>`;
        con = `<div class="contextmenu-ul" style="background: rgba(43, 44, 47, 0.6);
  border: 1px solid #2b2c2f;
  
  list-style: none;
  font-size: 14px;">${lis}</div>`;
        let divs = document.querySelectorAll(".contextmenu");
        if (divs.length != 0) {
          cesiumContainer.removeChild(divs[0]);
        }
        let div = document.createElement("div");
        div.className = "contextmenu";
        div.style.top = e.position.y + 60 + "px";
        div.style.left = e.position.x + 300 + "px";
        div.style.position = "fixed";
        div.innerHTML = con;
        div.onclick = function () {
          addMarkerMenu();
        };
        cesiumContainer.append(div);
      }
    }
    // 添加覆盖物以及飞往此处
    function addMarkerMenu() {
      //右键菜单添加Marker标记
      let cesiumContainer = document.querySelector("#g-container");
      if (!cesiumContainer) {
        return;
      }
      let divs = document.querySelectorAll(".contextmenu");
      cesiumContainer.removeChild(divs[0]);
      if (contextMenuPositon.value && contextMenuPositon.value.length > 0) {
        const lng = safeParseFloat(contextMenuPositon.value[0]);
        const lat = safeParseFloat(contextMenuPositon.value[1]);
        const aslheight = safeParseFloat(contextMenuPositon.value[2]);
        if (lng && lat && aslheight) {
          onFlyToConfirm(true, lng, lat, aslheight);
          flyData.value.push(contextMenuPositon.value);
          mapAimPoint(contextMenuPositon.value, flyData.value.length);
        }
      }
    }
    // 绘制图层组的数据
    function initDraw(data: any) {
      if (data && data.length > 0) {
        mouseEntityId.value = [];
        data.map((item: any) => {
          mouseEntityId.value.push(item.id);
          let itemobj = {};
          // 点
          if (item.resource.type == 0) {
            itemobj = {
              id: item.id,
              positions: item.resource.content.geometry.coordinates,
              name: item.name,
              type: "billboard",
              // "iconImg": "./easy3d/images/plot/billboard.png",
              style: {
                image: pin2d8cf0,
                scale: 1.5,
                label: "",
                color: "#2D8CF0",
              },
              styleType: "billboard",
            };
          }
          // 线
          if (item.resource.type == 1) {
            // console.log(2677,item);

            itemobj = {
              id: item.id,
              positions: item.resource.content.geometry.coordinates,
              name: item.name,
              type: "polyline",
              styleType: "polyline",
              style: {
                clampToGround: true,
                color: "#2D8CF0",
              },
            };
          }
          // 面
          if (item.resource.type == 2) {
            itemobj = {
              id: item.id,
              positions: item.resource.content.geometry.coordinates[0],
              name: item.name,
              type: "polygon",
              styleType: "polygon",
              style: {
                color: "#00FFFF",
                colorAlpha: 0.3,
                outline: true,
                outlineColor: "#2D8CF0",
                heightReference: 1,
              },
            };
          }
          plotDrawTool.value.createByPositions(itemobj);
        });
      }
    }
    // 切换图层时，先清除所有的标记，再重新绘制
    async function resetDraws() {
      if (!plotDrawTool.value) {
        return;
      }
      await plotDrawTool.value.removeAll();
      const data = layersOneArr.value[0]?.elements;

      await initDraws(data);
    }
    // 绘制图层组的数据 偏移后的
    function initDraws(data: any) {
      if (data && data.length > 0) {
        mouseEntityId.value = [];
        data.map((item: any) => {
          mouseEntityId.value.push(item.id);
          let itemobj = {};
          // 点
          if (item.resource.type == 0) {
            const lng = safeParseFloat(
              item.resource.content.geometry.coordinates[0] +
                mapSysData.mapsxyz[mapSysData.maps - 1].lng
            );
            const lat = safeParseFloat(
              item.resource.content.geometry.coordinates[1] +
                mapSysData.mapsxyz[mapSysData.maps - 1].lat
            );
            if (lng && lat) {
              const coordinates1 = isValidArray([lng, lat]);
              itemobj = {
                id: item.id,
                positions: coordinates1,
                name: item.name,
                type: "billboard",
                // "iconImg": "./easy3d/images/plot/billboard.png",
                style: {
                  image: pin2d8cf0,
                  scale: 1.5,
                  label: "",
                  color: "#2D8CF0",
                },
                styleType: "billboard",
              };
            }
          }
          // 线
          if (item.resource.type == 1) {
            let polylineArr = [] as any;
            if (
              item.resource.content.geometry?.coordinates &&
              item.resource.content.geometry?.coordinates.length > 0
            ) {
              item.resource.content.geometry.coordinates.map((item: any) => {
                const lng = safeParseFloat(
                  item[0] + mapSysData.mapsxyz[mapSysData.maps - 1].lng
                );
                const lat = safeParseFloat(
                  item[1] + mapSysData.mapsxyz[mapSysData.maps - 1].lat
                );
                if (lng && lat) {
                  const possd = isValidArray([lng, lat]);
                  if (possd && possd.length > 0) {
                    polylineArr.push(possd);
                  }
                }
              });
            }
            itemobj = {
              id: item.id,
              positions: polylineArr,
              name: item.name,
              type: "polyline",
              styleType: "polyline",
              style: {
                clampToGround: true,
                color: "#2D8CF0",
              },
            };
          }
          // 面
          if (item.resource.type == 2) {
            let polygonArr = [] as any;
            if (
              item.resource.content.geometry?.coordinates[0] &&
              item.resource.content.geometry?.coordinates[0].length > 0
            ) {
              item.resource.content.geometry.coordinates[0].map((item: any) => {
                const lng = safeParseFloat(
                  item[0] + mapSysData.mapsxyz[mapSysData.maps - 1].lng
                );
                const lat = safeParseFloat(
                  item[1] + mapSysData.mapsxyz[mapSysData.maps - 1].lat
                );
                if (lng && lat) {
                  const psd = isValidArray([lng, lat]);
                  if (psd && psd.length > 0) {
                    polygonArr.push(psd);
                  }
                }
              });
            }
            itemobj = {
              id: item.id,
              positions: polygonArr,
              name: item.name,
              type: "polygon",
              styleType: "polygon",
              style: {
                color: "#00FFFF",
                colorAlpha: 0.3,
                outline: true,
                outlineColor: "#2D8CF0",
                heightReference: 1,
              },
            };
          }

          plotDrawTool.value.createByPositions(itemobj);
        });
      }
    }
    // 标记
    function draw(type: MapDoodleType, bool: boolean) {
      if (!plotDrawTool.value) return;
      // mapclickFlag.value = false
      state.currentType = type;
      let item = {};
      if (type == "pin") {
        item = {
          name: "图标",
          type: "billboard",
          // "iconImg": "./easy3d/images/plot/billboard.png",
          style: {
            image: pin2d8cf0,
            scale: 1.5,
            label: "",
            color: "#2D8CF0",
          },
          styleType: "billboard",
        };
      }
      if (type == "polyline") {
        item = {
          name: "线",
          type: "polyline",
          styleType: "polyline",
          style: {
            clampToGround: true,
            color: "#2D8CF0",
          },
        };
      }
      if (type == "polygon") {
        item = {
          name: "面",
          type: "polygon",
          styleType: "polygon",
          style: {
            color: "#00FFFF",
            colorAlpha: 0.3,
            outline: true,
            outlineColor: "#2D8CF0",
            heightReference: 1,
          },
        };
      }
      plotDrawTool.value.start(item);
    }

    // dock 控制指令
    const {
      controlPanelVisible,
      setControlPanelVisible,
      sendDockControlCmd,
      dockDebugOnOff,
    } = useDockControl();

    // 获取地图参数
    const mapcenterPos = ref<any>([]);
    const getMapData = async () => {
      mapcenterPos.value = [];
      const res = await getFlyNum(
        { sysName: sysType[2].key },
        workspaceId.value
      );
      // console.log(93,res);
      if (res.code == 0) {
        if (res?.data?.sys_value) {
          const sysValue = JSON.parse(res?.data?.sys_value);
          const lng = sysValue?.lng;
          const lat = sysValue?.lat;
          if (lng && lat && safeParseFloat(lng) && safeParseFloat(lat)) {
            const points = isValidArray([
              safeParseFloat(lng),
              safeParseFloat(lat),
            ]);
            if (points && points.length > 0) {
              mapcenterPos.value = points;
            }
          }
        }
      }
    };
    // 初始化视锥体辅助地图
    function initfrustumMap() {
      if (frustumMap) {
        return;
      }
      // 创建Viewer实例，不显示地图和地形
      frustumMap = new Cesium.Viewer("frustummap", {
        imageryProvider: false, // 不使用影像图层
        terrainProvider: false, // 不使用地形图层
        baseLayerPicker: false, // 隐藏基础图层选择器
        navigationHelpButton: false, // 隐藏导航帮助按钮
        geocoder: false, // 隐藏地理编码搜索框
        homeButton: false, // 隐藏主页按钮
        infoBox: false, // 隐藏信息框
        sceneModePicker: false, // 隐藏场景模式选择器
        timeline: false, // 隐藏时间轴
        animation: false, // 隐藏动画控件
        fullscreenButton: false, // 隐藏全屏按钮
        showRenderLoopErrors: false, // 关闭默认错误弹框
      });
      frustumMap.scene.backgroundColor = Cesium.Color.BLACK;
      frustumMap.scene.globe.show = false; // 隐藏地球实体
      // console.log(2649,frustumMap);
    }
    onMounted(async () => {
      stopWatchList.value = [];
      await getMapData();
      initfrustumMap();
      const arrs = await getMapDataApi();
      // console.log(22033,arrs);
      if (arrs?.mapsxyz) {
        mapSysData.mapsxyz = arrs?.mapsxyz;
      }
      if (arrs?.maps) {
        mapSysData.maps = arrs?.maps;
        layerVisible.value = arrs?.maps;
      }
      getBuildAllList();
      const app = getApp();
      try {
        useGMapManageHook.globalPropertiesConfig(app, mapcenterPos.value);
      } catch (error) {
        console.log("tsa-initmap", error);
      }
      overPathOne.value = 0;
      setTimeout(() => {
        // console.log(1982, root.$mapinstancegmap, root.$handler);
        mousemove();
        if (root.$mapinstancegmap?.viewer) {
          if (loadModelHook) {
            loadModelHook.gloabinitModel(root.$mapinstancegmap.viewer);
          }
          plotDrawTool.value = new mouseTools(root.$mapinstancegmap.viewer, {
            canEdit: true,
          });
        }
        getElementGroups("init");
        const arr = localStorage.getItem("AUTH_ID")
          ? localStorage.getItem("AUTH_ID")?.split(",")
          : [];
        if (arr && arr.length > 0) {
          authIds.value = arr;
        }
        // 工地标记是否打开
        getBuildFlag();
        // 清除视锥体
        deviceTsaUpdateHook && deviceTsaUpdateHook.clearFrustum();
        if (root.$mapinstancegmap && root.$mapinstancegmap.viewer) {
          // 监听 地图错误弹框
          root.$mapinstancegmap.viewer.scene.renderError.addEventListener(
            function () {
              maperrorFlag.value = true;
            }
          );
          root.$mapinstancegmap.viewer.camera.changed.addEventListener(() => {
            // 获取相机的 heading 属性，单位为弧度
            const heading = root.$mapinstancegmap.camera.heading;
            // 将弧度转换为角度
            const headingDegrees = Math.ceil(Cesium.Math.toDegrees(heading));
            mapcompassInfo.angle = headingDegrees;
          });
        }
      }, 100);
      getAllDevice();
    });
    // 用来存放标记点的id，当每次data数据改变时，看mouseEntityId是否含有id，有就return，没有就添加进去
    const mouseEntityId = ref<any>([]);
    // 监听鼠标添加标记，plotDrawTool.value为鼠标所包含的所有数据，只要改变就会触发
    stopWatchList.value.push(
      watch(
        () => plotDrawTool.value?.entityObjArr.length,
        (data) => {
          if (data) {
            if (!state.currentType) {
              return;
            }
            const entityItem = plotDrawTool.value.entityObjArr[data - 1];
            if (!mouseEntityId.value.includes(entityItem.attr.id)) {
              mouseEntityId.value.push(entityItem.attr.id);
              mouseEntityId.value = [...new Set(mouseEntityId.value)];
              saveDrawData(entityItem);
              state.currentType = "";
              // mapclickFlag.value = true
            }
          }
        },
        {
          deep: true,
        }
      )
    );
    // 监听当前正在编辑的实体类  ?.nowEditEntityObjClickId 监听不到，通过浏览器来缓存
    stopWatchList.value.push(
      watch(
        () => plotDrawTool.value,
        (data) => {
          if (data) {
            if (data.nowEditEntityObjClick) {
              const entityId = localStorage.getItem("ENTITY_ID");
              if (entityId && entityId == data.nowEditEntityObjClick?.attr.id) {
                drawVisible.value = true;
                entityData.value = data.nowEditEntityObjClick?.attr;
                // console.log('2822noe',data.nowEditEntityObjClick, entityId, entityData.value);
              }
            }
          }
        },
        {
          deep: true,
        }
      )
    );

    // 重置 heading
    const resetHeading = () => {
      if (root.$mapinstancegmap?.viewer) {
        const camera = root.$mapinstancegmap.viewer.camera;
        camera.setView({
          orientation: {
            heading: Cesium.Math.toRadians(0.1),
            pitch: camera.pitch,
            roll: camera.roll, // camera.roll
          },
        });
        mapcompassInfo.angle = 0;
      }
    };
    // 获取图层组
    async function getElementGroups(type?: string) {
      const result = await getElementGroupsReq({
        groupId: "",
        isDistributed: true,
      });

      mapLayers.value = result.data;
      // mapLayers.value = updateWgs84togcj02()
      if (type && type === "init") {
        store?.dispatch("setLayerInfo", mapLayers.value);
      }
      store?.commit("SET_LAYER_INFO", mapLayers.value);
      const layersOne = result.data.filter(
        (item: any) => item.id == shareId.value
      );
      // console.log('2791one',layersOne,shareId.value);
      if (!layersOne[0]?.elements) {
        return;
      }
      layersOneArr.value = layersOne;
      initDraws(layersOne[0].elements);
    }
    function updateWgs84togcj02() {
      const layers = mapLayers.value;
      layers.forEach((item) => {
        if (item.elements) {
          item.elements.forEach((ele) => {
            updateCoordinates("wgs84-gcj02", ele);
          });
        }
      });
      return layers;
    }
    // 调取接口保存数据
    async function saveDrawData(data: any) {
      // 图标 点
      let params = {
        id: data.attr.id + "",
        name: data.name,
        resource: {},
      } as any;
      if (data.type == "billboard") {
        // 点
        const coordinates = lngLatFormat(data.position) as any;
        // 做偏移
        params.resource = {
          content: {
            geometry: {
              coordinates: coordinates,
              type: "Point",
            },
            type: "Feature",
            properties: {
              clampToGround: true,
              color: data.attr?.style?.color,
            },
          },
          type: 0,
        };
      } else if (data.type == "polyline") {
        // 线
        let coordinates = [] as any;
        if (data.positions && data.positions.length > 0) {
          data.positions.map((item: any) => {
            const pos = lngLatFormat(item);
            coordinates.push(pos);
          });
        }
        params.resource = {
          content: {
            geometry: {
              coordinates: coordinates,
              type: "LineString",
            },
            type: "Feature",
            properties: {
              clampToGround: true,
              color: data.attr?.style?.color,
            },
          },
          type: 1,
        };
      } else if (data.type == "polygon") {
        // 面
        let coordinates = [[]] as any;
        if (data.positions && data.positions.length > 0) {
          data.positions.map((item: any) => {
            const pos = lngLatFormat(item);
            coordinates[0].push(pos);
          });
        }
        params.resource = {
          content: {
            geometry: {
              coordinates: coordinates,
              type: "Polygon",
            },
            type: "Feature",
            properties: {
              // clampToGround: true,
              color: data.attr?.style?.color,
            },
          },
          type: 2,
        };
      }
      await postElementsReq(shareId.value, params);
    }
    // 将 Cartesian3 坐标转换为经纬度（弧度）
    function lngLatFormat(data: any) {
      if (!data) {
        return;
      }
      const cartesian = new Cesium.Cartesian3(data.x, data.y, data.z); // 替换为实际的 Cartesian3 坐标
      const cartographic = Cesium.Cartographic.fromCartesian(cartesian);
      const longitude = Cesium.Math.toDegrees(cartographic.longitude).toFixed(
        6
      ); // 经度
      const latitude = Cesium.Math.toDegrees(cartographic.latitude).toFixed(6); // 纬度
      const height = cartographic.height.toFixed(0); // 高度
      // 做偏移
      const lng = safeParseFloat(
        parseFloat(longitude) - mapSysData.mapsxyz[mapSysData.maps - 1].lng
      );
      const lat = safeParseFloat(
        parseFloat(latitude) - mapSysData.mapsxyz[mapSysData.maps - 1].lat
      );
      const heights = safeParseFloat(
        parseInt(height) - mapSysData.mapsxyz[mapSysData.maps - 1].height
      );
      if (lng && lat && heights) {
        return [lng, lat, heights];
      }
    }
    function setLayers(resource: PostElementsBody) {
      const layers = store.state.Layers;
      const layer = layers.find((item) => item.id.includes(shareId.value));
      if (layer?.elements) {
        (layer?.elements as any[]).push(resource);
      }
      store.commit("SET_LAYER_INFO", layers);
    }
    function updateCoordinates(transformType: string, element: any) {
      const geoType = element.resource?.content.geometry.type;
      const type = element.resource?.type as number;
      if (element.resource) {
        if (MapElementEnum.PIN === type) {
          const coordinates = element.resource?.content.geometry
            .coordinates as GeojsonCoordinate;
          if (transformType === "wgs84-gcj02") {
            const transResult = wgs84togcj02(
              coordinates[0],
              coordinates[1]
            ) as GeojsonCoordinate;
            element.resource.content.geometry.coordinates = transResult;
          } else if (transformType === "gcj02-wgs84") {
            const transResult = gcj02towgs84(
              coordinates[0],
              coordinates[1]
            ) as GeojsonCoordinate;
            element.resource.content.geometry.coordinates = transResult;
          }
        } else if (MapElementEnum.LINE === type && geoType === "LineString") {
          const coordinates = element.resource?.content.geometry
            .coordinates as GeojsonCoordinate[];
          if (transformType === "wgs84-gcj02") {
            coordinates.forEach((coordinate) => {
              coordinate = wgs84togcj02(
                coordinate[0],
                coordinate[1]
              ) as GeojsonCoordinate;
            });
          } else if (transformType === "gcj02-wgs84") {
            coordinates.forEach((coordinate) => {
              coordinate = gcj02towgs84(
                coordinate[0],
                coordinate[1]
              ) as GeojsonCoordinate;
            });
          }
          element.resource.content.geometry.coordinates = coordinates;
        } else if (MapElementEnum.LINE === type && geoType === "Polygon") {
          const coordinates = element.resource?.content.geometry
            .coordinates[0] as GeojsonCoordinate[];

          if (transformType === "wgs84-gcj02") {
            coordinates.forEach((coordinate) => {
              coordinate = wgs84togcj02(
                coordinate[0],
                coordinate[1]
              ) as GeojsonCoordinate;
            });
          } else if (transformType === "gcj02-wgs84") {
            coordinates.forEach((coordinate) => {
              coordinate = gcj02towgs84(
                coordinate[0],
                coordinate[1]
              ) as GeojsonCoordinate;
            });
          }
          element.resource.content.geometry.coordinates = [coordinates];
        }
      }
    }
    onBeforeUnmount(() => {
      overPathOne.value = 0;
    });
    // const
    // 切换地图与视频盒子
    function switchDiv(index: number) {
      shrinkMap.value = true;
      shrinkVedio.value = true;
      mapNum.value = index;
      switchVedio.value = !switchVedio.value;
    }
    // 隐藏视频小盒子
    function shrinkBox(index: number) {
      // switchVedio.value false为视频在下,地图在上，true视频在上，地图在下
      if (switchVedio.value) {
        if (mapNum.value != index) {
          onlineVedioData.value[index].isShow = false;
          let nums = 0;
          onlineVedioData.value.map((item: any, itemIndex: any) => {
            if (item.dockStatus && item.isShow) {
              item.bottomNum = nums;
              nums++;
            }
            return item;
          });
        } else {
          // true 隐藏地图
          shrinkMap.value = false;
        }
      } else {
        // false隐藏视频
        // shrinkVedio.value = false;
        onlineVedioData.value[index].isShow = false;
        let nums = 0;
        onlineVedioData.value.map((item: any, itemIndex: any) => {
          if (item.dockStatus && item.isShow) {
            item.bottomNum = nums;
            nums++;
          }
          return item;
        });
      }
    }
    // 显示视频小盒子
    function boostBox(index: any) {
      if (index == -1) {
        // 显示地图
        shrinkMap.value = true;
      } else {
        // 显示视频
        onlineVedioData.value[index].isShow = true;
        let nums = 0;
        onlineVedioData.value.map((item: any, itemIndex: any) => {
          if (item.dockStatus && item.isShow) {
            item.bottomNum = nums;
            nums++;
          }
          return item;
        });
      }
    }
    // 是否显示收缩、切换按钮
    function isSwichShrink(index: number) {
      // 当地图切换到视频小窗口时，点击隐藏
      // shrinkMap true为显示地图窗口，false为隐藏
      if (!shrinkMap.value) {
        // 点击地图隐藏时
        if (index == mapNum.value) {
          return false;
        } else {
          return true;
        }
      } else {
        return true;
      }
    }
    // 收缩 控制键盘
    function controlShrink() {
      shrinkControl.value = false;
      // 收缩时取消地图上的设置目标点
      mapclickFlag.value = false;
    }
    // 显示 控制键盘
    function controlBoost() {
      shrinkControl.value = true;
      //显示时取消地图上的设置目标点
      mapclickFlag.value = true;
    }
    stopWatchList.value.push(
      watch(
        () => store?.state.manualKey.data,
        (data: any) => {
          if (data && data.length > 0 && props.checkPlaneSn) {
            data.map((item: any) => {
              if (item.sn == props.checkPlaneSn) {
                controlStatusMessage.value = item.data;
              }
            });
          } else {
            controlStatusMessage.value = {};
          }
        },
        {
          deep: true,
        }
      )
    );
    // 地图倾斜角度，true为地图倾斜，false地图不倾斜
    function mappitch(val: boolean) {
      mappitchFlag.value = val;
    }
    const bolmqttFlags = ref<boolean>(true);
    // 监听mqttflag的值
    stopWatchList.value.push(
      watch(
        () => store?.state.ALL_mqttFlag,
        (val) => {
          // console.log('mqtt123标志显示 ',val);
          bolmqttFlags.value = val;
        },
        {
          deep: true,
          immediate: true,
        }
      )
    );
    // 获取所有工地列表
    function getBuildAllList() {
      const datas = {
        current: 1,
        size: -1,
        prs_name: "",
        supervision: true,
        street: "",
      };
      getBuildListApi(datas).then((res) => {
        const roelsList = res.data.records;
        buildAllData.value = roelsList;
        if (buildAllData.value && buildAllData.value.length > 0) {
          buildAllData.value.map((item: any) => {
            if (
              item.prs_long &&
              item.prs_lat &&
              safeParseFloat(item.prs_long) &&
              safeParseFloat(item.prs_lat)
            ) {
              item.pos = [
                safeParseFloat(item.prs_long),
                safeParseFloat(item.prs_lat),
              ];
            }
            return item;
          });
        }
      });
    }
    // 绘制工地图标
    function openBuild() {
      if (deviceTsaUpdateHook) {
        if (buildAllData.value && buildAllData.value.length > 0) {
          buildAllData.value.map((item: any) => {
            deviceTsaUpdateHook.drawMarker(item.pos, item.prs_name);
          });
        }
      }
    }
    // 设置工地标记
    async function setBuildFlag(site: number) {
      // site 0关1开
      const res = await setBuildFlagApi(site);
      if (res.code == 0) {
        // message.success('设置成功')
      }
      if (site == 0) {
        await closeBuild();
      }
      if (site == 1) {
        await openBuild();
      }
    }
    // 获取工地标记
    async function getBuildFlag() {
      const res = await getBuildFlagApi();
      buildFlag.value = false;
      buildSwitch.value = false;
      if (res.code == 0) {
        if (res.data) {
          buildFlag.value = true;
          buildSwitch.value = true;
          await openBuild();
        }
      }
    }
    // 删除工地图标
    function closeBuild() {
      if (deviceTsaUpdateHook) {
        deviceTsaUpdateHook.destoryMarker();
      }
    }
    // 工地switch 改变
    const buildChange = () => {
      buildSwitch.value = !buildSwitch.value;
      if (buildSwitch.value) {
        const modals = Modal.confirm({
          title: "关闭工地标记",
          icon: createVNode(ExclamationCircleOutlined),
          content: "",
          centered: true,
          class: "modal-class",
          async onOk(e) {
            await modals.destroy();
            buildFlag.value = false;
            buildSwitch.value = false;
            // await closeBuild()
            await setBuildFlag(0);
          },
          onCancel() {
            buildFlag.value = true;
            buildSwitch.value = true;
          },
        });
      } else {
        const modal1 = Modal.confirm({
          title: "打开工地标记",
          icon: createVNode(ExclamationCircleOutlined),
          content: "",
          centered: true,
          class: "modal-class",
          async onOk(e) {
            buildFlag.value = true;
            buildSwitch.value = true;
            await modal1.destroy();
            // await openBuild()
            await setBuildFlag(1);
          },
          onCancel() {
            buildFlag.value = false;
            buildSwitch.value = false;
          },
        });
      }
    };
    onUnmounted(() => {
      if (stopWatchList.value) {
        stopWatchList.value.forEach((stopWatch: any) => stopWatch());
      }
      // 清除视锥体
      deviceTsaUpdateHook && deviceTsaUpdateHook.clearFrustum();
      if (frustumMap) {
        if (!frustumMap.isDestroyed()) {
          frustumMap.destroy();
          frustumMap = null;
        }
      }
    });
    return {
      draw,
      mouseMode,
      drawVisible,
      osdVisible,
      pin,
      state,
      M30,
      deviceInfo,
      EGear,
      EModeCode,
      str,
      EDockModeCode,
      controlPanelVisible,
      dockDebugOnOff,
      setControlPanelVisible,
      NetworkStateTypeEnum,
      NetworkStateQualityEnum,
      RainfallEnum,
      DroneInDockEnum,
      altHeight,
      lonLatAlt,
      layerVisible,
      starandLayer,
      starLayer,
      starLayerMapbox,
      hideLayer,
      showLayer,
      isShowLayer,
      switchDiv,
      switchVedio,
      shrinkBox,
      shrinkVedio,
      boostBox,
      shrinkMap,
      shrinkControl,
      controlShrink,
      controlBoost,
      mapclick,
      aimpoints,
      aircraftpositionings,
      cancalemapclick,
      rightclick,
      cleardata,
      toVedioDatas,
      toVedio,
      entityData,
      // controlStatus,
      controlStatusMessage,
      // flightController,
      flightControllerFlag,
      mappitch,
      bolmqttFlags,
      onlineVedioData,
      shuiping,
      haiba,
      fensu,
      zitai,
      chuizhi,
      mapNum,
      isSwichShrink,
      authIds,
      starandLayerXin,
      buildSwitch,
      buildFlag,
      buildChange,
      leftDoubleClick,
      checkList,
      deviceinfoObj,
      maperrorFlag,
      mapcompassInfo,
      resetHeading,
    };
  },
});
</script>

<style lang="scss" scoped>
.flex-center {
  display: flex;
  justify-content: space-between;
  align-content: center;
  > div {
    width: 50%;
  }
}
.blocks {
  width: 13px;
  height: 13px;
  background: red;
  // margin-right: 5px;
}
.txt12 {
  font-size: 12px;
  color: #ccc;
  line-height: 22px;
}
.circles {
  width: 22px;
  height: 22px;
  border-radius: 50%;
  font-size: 13px;
  color: #fff;
  text-align: center;
  line-height: 22px;
  // border: 1px solid #ccc;
  margin-right: 5px;
}
// 指南针
.gmap-heading-box {
  position: absolute;
  top: 90px;
  right: 10px;
}
// 手控状态
.control-status-box {
  position: absolute;
  top: 1px;
  right: 1px;
  background: rgba(0, 0, 0, 0.75);
  min-width: 200px;
  padding: 5px;
  // height: 50px;
  border-radius: 10px;
  // display: flex;
  // align-items: center;
  // justify-content: center;
  color: #fff;
}
.map-box {
  width: 100%;
  height: 100%;
  position: relative;
}
.vedio-box {
  // width: 350px;
  // height: 280px;
  width: 400px;
  height: 320px;
  position: absolute;
  background: #333333;
  bottom: 10px;
  right: 60px;
  // right: 10px;
  // border: 1px solid #ccc;
  border-radius: 10px;
}
.vedio-box-active {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
}
.zindex10 {
  z-index: 90;
}
.map-wrapper-active {
  // width: 350px !important;
  // height: 280px !important;
  width: 400px !important;
  height: 320px !important;
  bottom: 10px;
  right: 60px;
  // right: 10px;
  z-index: 100;
}
.switch-btn {
  position: fixed;
  bottom: 330px;
  // bottom: 265px;
  // right: 330px;
  // right: 380px;
  right: 430px;
  z-index: 102;
  // width: 36px;
  // height: 36px;
  width: 24px;
  height: 20px;
  background: rgba(89, 89, 89, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-size: 15px;
  &:hover {
    background: #1890ff;
  }
}
.shrink-box {
  position: fixed;
  bottom: 265px;
  right: 405px;
  // right: 305px;
  z-index: 102;
  width: 24px;
  height: 20px;
  // width: 36px;
  // height: 36px;
  background: rgba(89, 89, 89, 0.6);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: #fff;
  font-size: 15px;
  // font-size: 20px;
  &:hover {
    background: #1890ff;
  }
}
.boost-box {
  position: absolute;
  bottom: 65px;
  right: 18px;
  width: 40px;
  height: 40px;
  // background-color: rgba(255, 255, 255, 0.5);
  background: rgba(51, 51, 51, 0.75);
  border: 2px solid rgba(185, 217, 237, 0.5);
  // background-color: #fff;
  cursor: pointer;
  padding: 3px;
  border-radius: 50%;
  z-index: 99;
  font-size: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  color: #b9d9ed;
  font-weight: bold;
  // color: rgba(64, 169, 255,1);
}
.context_menu {
  position: relative;
  // min-width: 12rem;
  padding: 10px;
}
.layers-box1 {
  position: absolute;
  bottom: 15px;
  right: 16px;
  width: 40px;
  height: 40px;
  // background-color: #fff;
  background: rgba(0, 0, 0, 0.8);
  border: 2px solid #009bff;
  cursor: pointer;
  padding: 3px;
  border-radius: 50%;
  z-index: 100;
  .layers {
    width: 34px;
    height: 34px;
    border-radius: 50%;
    text-align: center;
    line-height: 34px;
    font-size: 14px;
    color: #009bff;
    font-weight: 700;
  }
  .layer-overhide {
    width: 100%;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
  }
}
.layers-type {
  position: absolute;
  bottom: 20px;
  right: 40px;
  background-color: #333333a6;
  width: 380px;
  padding: 8px;
  color: #fff;
  box-shadow: 0 0 4px 0 rgba(0, 0, 0, 0.5);
  .layers-bg {
    position: relative;
    width: 25%;
    height: 40px;
    border: 1px solid #ccc;
    color: #fff;
    // margin: -2px;
    cursor: pointer;
    box-sizing: content-box;
    background: 50% no-repeat content-box;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .layer-text {
    padding: 3px;
  }
  .layer-bg {
    color: #1890ff;
  }
  .layer-border {
    border: 1px solid #1890ff;
  }
}
.info {
  margin-bottom: 12px;
  border-radius: 3px;
  top: 12px;
  background-color: white;
  width: auto;
  border-width: 0;
  right: 12px;
  box-shadow: 0 2px 6px 0 rgba(114, 124, 245, 0.5);
}
.bottom-tool {
  position: absolute;
  bottom: 0px;
  left: 0px;
  width: auto;
  padding: 2px 2px;
  z-index: 10;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: rgba(238, 238, 235, 0.6);
  font-size: 12px;
}
// 左上复选框
.left-check-box {
  position: absolute;
  top: 0;
  left: 310px;
  background-color: rgba(0, 0, 0, 0.75);
  width: 80px;
  padding: 5px;
  border-radius: 5px;
  .left-checkgroup {
    width: 100%;
    &:deep(.ant-checkbox-wrapper) {
      color: #fff !important;
    }
  }
}
// 视频
.left-vedio-wrapper {
  position: absolute;
  left: 310px;
  top: 30px;
  background-color: rgba(0, 0, 0, 0.75);
  width: 400px;
  height: 320px;
  padding: 5px;
  border-radius: 5px;
  .left-vedio-box {
    width: 100%;
    height: 100%;
    position: relative;
  }
}
.ml20 {
  margin-left: 20px;
}
.ml2 {
  margin-left: 2px;
}
// 手动控制
.control-box {
  position: absolute;
  bottom: 30px;
  // left: 35%;
  left: 50%;
  transform: translateX(-50%);
  // width: 580px;
  height: 150px;
  background: rgb(0, 0, 0, 0.75);
  border-radius: 10px;
  .control-shrink {
    position: absolute;
    left: 50%;
    top: -12px;
    transform: translateX(-50%);
    color: #1890ff;
    font-size: 23px;
    cursor: pointer;
    z-index: 101;
    &:hover {
      color: #1890ff;
    }
  }
}
.control-box-shrink {
  position: absolute;
  left: 40%;
  transform: translateX(-50%);
  bottom: 40px;
  width: 35px;
  height: 35px;
  background: #333;
  border-radius: 50%;
  color: #fff;
  font-size: 23px;
  text-align: center;
  line-height: 35px;
  cursor: pointer;
  &:hover {
    color: #1890ff;
  }
}
.g-map-wrapper {
  height: 100%;
  width: 100%;
  position: absolute;
  // left: 0;
  // top: 0;
  // 地图标记图层
  .map-layer-box {
    position: absolute;
    top: 250px;
    right: 16px;
    background: #333;
    color: #fff;
    border-radius: 10px;
    width: 350px;
    padding: 20px;
  }
  .g-action-panle {
    position: absolute;
    top: 150px;
    right: 16px;
    .g-action-item {
      width: 28px;
      height: 28px;
      // background: white;
      color: $primary;
      border-radius: 2px;
      line-height: 28px;
      text-align: center;
      margin-bottom: 2px;
    }
    .g-action-item:hover {
      border: 1px solid $primary;
      border-radius: 2px;
    }
  }
  .selection {
    border: 2px solid $primary;
    border-radius: 2px;
  }

  // antd button 光晕
  &:deep(.ant-btn) {
    &::after {
      display: none;
    }
  }
}
.osd-panel {
  position: absolute;
  left: 10px;
  top: 10px;
  width: 480px;
  background: black;
  color: white;
  border-radius: 2px;
  opacity: 0.7;
}
.osd > div {
  margin-top: 5px;
  padding-left: 5px;
}

.circle {
  border-radius: 50%;
  width: 10px;
  height: 10px;
}

.battery-slide {
  .capacity-percent {
    background: #00ee8b;
  }
  .return-home {
    background: #ff9f0a;
  }
  .landing {
    background: #f5222d;
  }
  .white-point {
    width: 4px;
    height: 4px;
    border-radius: 50%;
    background: white;
    bottom: -0.5px;
  }
  .battery {
    background: #141414;
    color: #00ee8b;
    margin-top: -10px;
    height: 20px;
    width: auto;
    border-left: 1px solid #00ee8b;
    padding: 0 5px;
  }
}
.battery-slide > div {
  position: absolute;
  min-height: 2px;
  border-radius: 2px;
}
.contextmenu-ul {
  background: rgba(43, 44, 47, 0.6);
  border: 1px solid #2b2c2f;
  min-width: 110px;
  list-style: none;
  font-size: 14px;
}
.contextmenu-ul a {
  border-bottom: 1px solid rgba(128, 128, 128, 0.5);
  padding: 6px 10px;
  transition: background-color 0.25s;
  display: block;
  clear: both;
  font-weight: 400;
  line-height: 1.6;
  white-space: nowrap;
  color: #edffff;
  text-decoration: none;
}

.contextmenu-ul li:last-child a {
  border-bottom: none;
}

.contextmenu-ul a:hover {
  background-color: #444d59;
  color: #fff;
  text-decoration: none;
}
// 视锥体 辅助地图
#frustummap {
  position: absolute;
  left: 0;
  top: 0;
  z-index: -1;
  width: 100%;
  height: 100%;
}
</style>